<template>
  <v-container class="fill-height" fluid>
    <v-navigation-drawer v-model="drawer" :absolute="$vuetify.breakpoint.mdAndUp" :fixed="$vuetify.breakpoint.smAndDown"
      right :app="$vuetify.breakpoint.smAndDown" width="260"
      :style="$vuetify.breakpoint.smAndDown ? 'z-index: 2000 !important;' : ''"
      :overlay-color="$vuetify.breakpoint.smAndDown ? 'rgba(0,0,0,0.5)' : ''"
      :overlay-opacity="$vuetify.breakpoint.smAndDown ? '0.5' : '0'" :hide-overlay="$vuetify.breakpoint.mdAndUp">
      <v-container class="pa-2">
        <div class="d-flex justify-space-between align-center mb-2">
          <h4 class="text-center" style="font-size: 14px; flex: 1">
            Lembar Jawaban
          </h4>
          <v-btn icon small @click="drawer = false" class="ml-2" style="z-index: 2001">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        <v-flex>
          <!-- Grid Layout untuk Lembar Jawaban -->
          <div class="jawaban-grid">
            <v-chip :class="{
              'accent accent--text jawaban-item': soal.ragu,
              'black black--text jawaban-item':
                !soal.jawab_huruf ||
                soal.jawab_huruf === '' ||
                soal.jawab === -1,
              'primary primary--text jawaban-item':
                soal.jawab_huruf &&
                soal.jawab_huruf !== '' &&
                soal.jawab !== -1,
            }" outlined label ripple v-for="(soal, n) in mapel.soal" :key="soal.id" @click="navigateToSoal(n)">
              <v-sheet width="20" height="20" :class="{
                'accent text-center white--text': soal.ragu,
                'grey darken-1 text-center white--text':
                  !soal.jawab_huruf ||
                  soal.jawab_huruf === '' ||
                  soal.jawab === -1,
                'primary text-center white--text':
                  soal.jawab_huruf &&
                  soal.jawab_huruf !== '' &&
                  soal.jawab !== -1,
              }" style="
                  border-radius: 3px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 10px;
                  font-weight: bold;
                ">
                {{ n + 1 }}
              </v-sheet>
            </v-chip>
          </div>
        </v-flex>
      </v-container>
    </v-navigation-drawer>
    <v-flex :class="{ 'py-2': $vuetify.breakpoint.smAndDown }">
      <v-layout row justify-center>
        <!-- Skeleton Loading -->
        <v-flex :class="{
          'xs10': $vuetify.breakpoint.smAndDown,
          'xs11 xl10': $vuetify.breakpoint.mdAndUp
        }" v-if="loading">
          <v-skeleton-loader type="article" class="my-4"></v-skeleton-loader>
          <v-skeleton-loader type="article" class="my-4"></v-skeleton-loader>
        </v-flex>
        <v-flex :class="{
          'xs10': $vuetify.breakpoint.smAndDown,
          'xs11 xl10': $vuetify.breakpoint.mdAndUp
        }" v-if="!loading">
          <!-- Progress Bar Ujian -->
          <div class="progress-ujian-wrapper" :class="{ 'progress-ujian-landscape': $vuetify.breakpoint.smAndDown && landscape }">
            <v-progress-linear
              :value="answeredPercentage"
              :color="answeredPercentage >= 100 ? 'success' : 'primary'"
              height="22"
              rounded
              class="mb-2"
            >
              <strong class="white--text" style="font-size: 11px;">{{ answeredCount }} dari {{ mapel.soal_count || 0 }} soal dijawab</strong>
            </v-progress-linear>
          </div>
          <v-layout row>
            <v-btn class="mb-5 text-none btn-kembali" depressed color="grey lighten-2" @click="dialogKembali = true"
              :class="{
                'landscape-floating-btn': $vuetify.breakpoint.smAndDown && landscape,
                'landscape-compact-btn': $vuetify.breakpoint.smAndDown && landscape
              }" :fab="$vuetify.breakpoint.xs && landscape" :small="$vuetify.breakpoint.smAndDown && landscape">
              <v-icon>mdi-chevron-left</v-icon>
              <span v-if="!($vuetify.breakpoint.xs && landscape)">Kembali</span>
            </v-btn>

            <!-- Floating Lembar Jawaban Button for Landscape Mobile -->
            <v-btn v-if="$vuetify.breakpoint.smAndDown && landscape" color="accent" @click="toggleDrawer"
              :fab="$vuetify.breakpoint.xs" :small="$vuetify.breakpoint.sm && !$vuetify.breakpoint.xs"
              class="landscape-floating-answer-btn">
              <v-icon v-if="$vuetify.breakpoint.xs">mdi-format-list-numbered</v-icon>
              <template v-else>
                <v-icon small class="mr-1">mdi-format-list-numbered</v-icon>
                <span class="black--text font-weight-bold text-none" style="font-size: 10px;">Jawaban</span>
              </template>
            </v-btn>

            <!-- Floating Timer for Landscape Mobile -->
            <div v-if="$vuetify.breakpoint.smAndDown && landscape" class="landscape-floating-timer">
              <v-icon class="mr-1" size="16">mdi-av-timer</v-icon>
              <span class="timer-text">
                {{ hours | two_digits }}:{{ minutes | two_digits }}:{{ seconds | two_digits }}
              </span>
            </div>

            <!-- Floating Timer for Portrait Mobile -->
            <div v-if="$vuetify.breakpoint.smAndDown && !landscape" class="portrait-floating-timer">
              <v-icon class="mr-1" size="16">mdi-av-timer</v-icon>
              <span class="timer-text">
                {{ hours | two_digits }}:{{ minutes | two_digits }}:{{ seconds | two_digits }}
              </span>
            </div>

            <!-- Floating Lembar Jawaban Button for Portrait Mobile -->
            <v-btn v-if="$vuetify.breakpoint.smAndDown && !landscape" color="accent" @click="toggleDrawer" small
              class="portrait-floating-answer-btn">
              <v-icon small class="mr-1">mdi-format-list-numbered</v-icon>
              <span class="black--text font-weight-bold text-none"
                style="font-size: 12px; pointer-events: none;">Jawaban</span>
            </v-btn>

            <v-card :loading="loading" tile :class="{
              'device-height': $vuetify.breakpoint.smAndDown,
              'desktop-full-height': $vuetify.breakpoint.mdAndUp
            }" width="100%">
              <!-- Header Tunggal Horizontal -->
              <v-toolbar color="primary" dark flat :class="toolbarClasses"
                :extended="$vuetify.breakpoint.smAndDown && portrait" :height="toolbarHeight">
                <!-- Desktop Layout -->
                <template v-if="$vuetify.breakpoint.mdAndUp">
                  <div style="
                      display: flex;
                      align-items: center;
                      width: 100%;
                      gap: 16px;
                    ">
                    <!-- Judul Buku -->
                    <div class="header-judul-horizontal" v-if="mapel.nama_mapel">
                      {{ mapel.nama_mapel }}
                    </div>
                    <!-- Separator -->
                    <div class="header-separator">|</div>
                    <!-- Nama Paket -->
                    <div class="header-paket-horizontal" v-if="mapel.nama_paket">
                      {{ mapel.nama_paket }}
                    </div>
                    <!-- Separator -->
                    <div class="header-separator">|</div>
                    <!-- Nomor Soal -->
                    <div class="header-soal-horizontal">
                      Soal {{ model + 1 }}
                    </div>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="mx-5">
                    <v-icon class="mr-1">mdi-av-timer</v-icon>{{ hours | two_digits }}:{{ minutes | two_digits }}:{{
                      seconds | two_digits
                    }}
                  </div>
                  <v-btn color="accent" @click="toggleDrawer" class="desktop-answer-btn">
                    <span class="black--text font-weight-bold text-none">Lembar Jawaban</span>
                  </v-btn>
                </template>

                <!-- Mobile Landscape Layout -->
                <template v-else-if="landscape">
                  <div class="mobile-landscape-toolbar-content">
                    <div class="mobile-landscape-info">
                      <span class="mobile-landscape-segment" v-if="mapel.nama_mapel">
                        {{ mapel.nama_mapel }}
                      </span>
                      <span class="mobile-landscape-separator" v-if="mapel.nama_mapel && mapel.nama_paket">
                        |
                      </span>
                      <span class="mobile-landscape-segment" v-if="mapel.nama_paket">
                        {{ mapel.nama_paket }}
                      </span>
                      <span class="mobile-landscape-separator">|</span>
                      <span class="mobile-landscape-segment">
                        Soal {{ model + 1 }} dari {{ mapel.soal_count || 0 }}
                      </span>
                    </div>
                    <v-spacer class="mobile-landscape-spacer"></v-spacer>
                    <div class="mobile-landscape-actions" v-if="!($vuetify.breakpoint.smAndDown && landscape)">
                      <div class="mobile-landscape-timer">
                        <v-icon class="mr-1" size="18">mdi-av-timer</v-icon>
                        <span class="mobile-landscape-timer-text">
                          {{ hours | two_digits }}:{{ minutes | two_digits }}:{{
                            seconds | two_digits
                          }}
                        </span>
                      </div>
                      <v-btn v-if="!($vuetify.breakpoint.smAndDown && landscape)" color="accent" small
                        class="mobile-landscape-answer-btn" @click="toggleDrawer">
                        <span class="black--text font-weight-bold text-none mobile-landscape-btn-text">
                          Lembar Jawaban
                        </span>
                      </v-btn>
                    </div>
                  </div>
                </template>

                <!-- Mobile Portrait Layout -->
                <template v-else>
                  <div class="mobile-header-content">
                    <!-- Only Question Number - Timer and Jawaban will be floating -->
                    <div class="mobile-header-top">
                      <div class="mobile-soal-number-main">
                        {{ mapel.nama_mapel || "" }} |
                        {{ mapel.nama_paket || "" }} | Soal {{ model + 1 }} dari
                        {{ mapel.soal_count || 0 }}
                      </div>
                    </div>
                  </div>
                </template>
              </v-toolbar>
              <v-carousel touchless v-model="model" hide-delimiters :show-arrows="false" :height="getCarouselHeight"
                :class="{
                  'carousel-with-sticky-header': $vuetify.breakpoint.smAndDown,
                }">
                <v-carousel-item v-for="soal in mapel.soal" :key="soal.id">
                  <v-container :class="{
                    'fill-height scroll-container-mobile': $vuetify.breakpoint.smAndDown,
                    'fill-height desktop-container': $vuetify.breakpoint.mdAndUp,
                  }" :style="$vuetify.breakpoint.mdAndUp ? 'overflow-y: hidden;' : 'overflow-y: scroll'">
                    <v-card-text :class="{
                      'pa-8 pt-0': $vuetify.breakpoint.smAndDown,
                      'pa-12 pt-4 desktop-content-scroll': $vuetify.breakpoint.mdAndUp,
                    }">
                      <v-layout row justify-center>
                        <v-flex xs12 :class="{
                          'black--text default-font': true,
                          'horizontal-scrollable-content':
                            soal.tipe_soal === 'menjodohkan',
                        }" :style="getFontSetting">
                          <audio controls v-if="soal.audio" ref="audioPlayer" :key="soal.id" class="soal-audio">
                            <source :src="soal.audio" />
                          </audio>
                          <div v-sanitize="soal.soal" style="
                              padding: 20px 0;
                              line-height: 1.6;
                              word-wrap: break-word;
                              overflow-wrap: break-word;
                            " class="soal-content"></div>
                          <template v-if="soal.tipe_soal === 'menjodohkan'">
                            <MatchingLine :left="soal.matching_left
                              ? soal.matching_left.map((item) => item.text)
                              : []
                              " :right="soal.matching_right
                                ? soal.matching_right.map((item) => item.text)
                                : []
                                " :value="getMatchingAnswers(soal)" @input="updateMatchingAnswers(soal, $event)" />
                          </template>
                          <template v-else-if="soal.tipe_soal === 'pg_kategori'">
                            <PGKategoriComponent :items="soal.pg_kategori || []" :left-label="soal.left_pgk || soal.left_label || 'Option 1'
                              " :right-label="soal.right_pgk || soal.right_label || 'Option 2'
                                " :pernyataan-label="soal.pernyataan_pgk ||
                                  soal.pernyataan_label ||
                                  'Pernyataan'
                                  " :value="getPGKategoriAnswers(soal)"
                              @input="updatePGKategoriAnswers(soal, $event)" />
                          </template>
                          <template v-else>
                            <!-- Tampilkan Pilihan dengan Radio/Checkbox di sebelah soal -->
                            <div class="pilihan-container">
                              <div v-if="
                                soal.tipe_soal === 'pilihan_ganda_kompleks'
                              " class="pilihan-list">
                                <div v-for="pilihan in soal.pilihan_jawaban" :key="pilihan.id" class="pilihan-item"
                                  :class="{
                                    'pilihan-selected':
                                      jawabanKompleksTerpilih.includes(
                                        pilihan.id
                                      ),
                                  }" @click="toggleJawabanKompleks(pilihan.id)" :data-pilihan-id="pilihan.id">
                                  <div class="pilihan-input">
                                    <input type="checkbox" :id="`pilihan-${pilihan.id}`" :value="pilihan.id"
                                      v-model="jawabanKompleksTerpilih" class="pilihan-checkbox"
                                      style="display: none" />
                                    <label :for="`pilihan-${pilihan.id}`" class="pilihan-label-checkbox">
                                      <span v-if="
                                        !jawabanKompleksTerpilih.includes(
                                          pilihan.id
                                        )
                                      " class="pilihan-kotak-kosong" @click="
                                        toggleJawabanKompleks(pilihan.id)
                                        "></span>
                                      <span v-else class="pilihan-kotak-terisi" @click="
                                        toggleJawabanKompleks(pilihan.id)
                                        ">✓</span>
                                    </label>
                                  </div>
                                  <div class="pilihan-text" v-sanitize="pilihan.jawaban"></div>
                                </div>
                              </div>
                              <div v-else class="pilihan-list">
                                <div v-for="pilihan in soal.pilihan_jawaban" :key="pilihan.id" class="pilihan-item"
                                  :class="{
                                    'pilihan-selected':
                                      jawabanTunggalTerpilih === pilihan.id,
                                  }" @click="pilihJawabanTunggal(pilihan.id)" :data-pilihan-id="pilihan.id">
                                  <div class="pilihan-input">
                                    <input type="radio" :id="`pilihan-${pilihan.id}`" :name="`soal-${soal.id}`"
                                      :value="pilihan.id" v-model="jawabanTunggalTerpilih" class="pilihan-radio"
                                      style="display: none" />
                                    <label :for="`pilihan-${pilihan.id}`" class="pilihan-label-radio">
                                      <span v-if="
                                        jawabanTunggalTerpilih !== pilihan.id
                                      " class="pilihan-lingkaran-kosong" @click="pilihJawabanTunggal(pilihan.id)">{{
                                        getHurufByPilihanId(pilihan.id)
                                      }}</span>
                                      <span v-else class="pilihan-lingkaran-terisi"
                                        @click="pilihJawabanTunggal(pilihan.id)">{{
                                          getHurufByPilihanId(pilihan.id)
                                        }}</span>
                                    </label>
                                  </div>
                                  <div class="pilihan-text" v-sanitize="pilihan.jawaban"></div>
                                </div>
                              </div>
                            </div>
                          </template>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-container>
                </v-carousel-item>
              </v-carousel>

              <v-card-actions :class="{
                'pa-5': $vuetify.breakpoint.mdAndUp,
                'desktop-actions': $vuetify.breakpoint.lgAndUp
              }" v-if="$vuetify.breakpoint.mdAndUp">
                <v-layout row justify-space-between align-center>
                  <!-- Tombol Ragu dan Navigasi Kiri -->
                  <div class="d-flex align-center">
                    <v-btn-toggle v-model="toggleRagu" color="accent" v-if="$vuetify.breakpoint.lgAndUp">
                      <v-btn class="font-weight-bold title mr-3 text-none ragu-btn" outlined large color="accent"
                        @click="ragu">
                        Ragu
                      </v-btn>
                    </v-btn-toggle>
                    <v-btn class="mr-3" large depressed color="success" @click="model--" :disabled="prev"
                      v-if="$vuetify.breakpoint.lgAndUp">
                      <v-icon>mdi-arrow-left-thick</v-icon>
                    </v-btn>

                    <v-btn-toggle v-model="toggleRagu" color="accent" v-if="$vuetify.breakpoint.mdAndDown">
                      <v-btn class="font-weight-bold title mr-3 text-none ragu-btn" outlined large color="accent"
                        @click="ragu">
                        Ragu
                      </v-btn>
                    </v-btn-toggle>
                    <v-btn class="mr-3" large depressed color="success" @click="model--" :disabled="prev"
                      v-if="$vuetify.breakpoint.mdAndDown">
                      <v-icon>mdi-arrow-left-thick</v-icon>
                    </v-btn>
                  </div>

                  <!-- Tombol Navigasi Kanan dan Selesai -->
                  <div class="d-flex align-center">
                    <v-btn class="mr-3" large depressed color="success" @click="model++" :disabled="next">
                      <v-icon>mdi-arrow-right-thick</v-icon>
                    </v-btn>
                    <!-- Reserved space untuk tombol selesai agar posisi next tidak bergeser -->
                    <div style="min-width: 120px">
                      <v-btn v-if="model === mapel.soal_count - 1" class="font-weight-bold title white--text text-none"
                        depressed large color="red" @click="cekSelesai">
                        Selesai
                      </v-btn>
                    </div>
                    <!-- Keyboard Shortcuts Help Tooltip -->
                    <v-tooltip top max-width="320">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small v-bind="attrs" v-on="on" class="ml-2">
                          <v-icon small color="grey">mdi-keyboard-outline</v-icon>
                        </v-btn>
                      </template>
                      <div>
                        <div class="font-weight-bold mb-1">Keyboard Shortcuts</div>
                        <div><kbd>&larr;</kbd> / <kbd>&rarr;</kbd> &mdash; Soal sebelumnya / selanjutnya</div>
                        <div><kbd>Ctrl</kbd>+<kbd>&larr;</kbd>/<kbd>&rarr;</kbd> &mdash; Lompat 5 soal</div>
                        <div><kbd>1</kbd>-<kbd>9</kbd> &mdash; Langsung ke soal nomor 1-9</div>
                        <div><kbd>Space</kbd> &mdash; Tandai ragu</div>
                      </div>
                    </v-tooltip>
                  </div>
                </v-layout>
              </v-card-actions>
              <v-toolbar bottom floating v-if="$vuetify.breakpoint.smAndDown" style="position: fixed; left: 0"
                :height="portrait ? 80 : 70" width="100%">
                <v-layout justify-space-between align-center v-if="portrait">
                  <!-- Tombol Kiri -->
                  <div class="d-flex align-center">
                    <v-btn depressed color="success" class="ma-1" @click="model--" :disabled="prev" height="40"
                      min-width="80">
                      <v-icon>mdi-arrow-left-thick</v-icon>
                    </v-btn>
                  </div>

                  <!-- Tombol Tengah -->
                  <div class="d-flex align-center">
                    <v-btn class="font-weight-bold text-none ma-1 ragu-btn"
                      :class="{ 'v-btn--active': getCurrentSoal.ragu }" outlined color="accent" @click="ragu"
                      height="40" min-width="80">
                      Ragu
                    </v-btn>
                    <!-- Tombol Selesai di tengah jika soal terakhir -->
                    <v-btn v-if="model === mapel.soal_count - 1" class="font-weight-bold white--text text-none ma-1"
                      depressed color="red" @click="cekSelesai" height="40" min-width="80">
                      Selesai
                    </v-btn>
                  </div>

                  <!-- Tombol Kanan -->
                  <div class="d-flex align-center">
                    <v-btn depressed color="success" class="ma-1" @click="model++" :disabled="next" height="40"
                      min-width="80">
                      <v-icon>mdi-arrow-right-thick</v-icon>
                    </v-btn>
                  </div>
                </v-layout>

                <v-layout justify-space-between align-center v-else>
                  <!-- Tombol Kiri -->
                  <div class="d-flex align-center">
                    <v-btn depressed color="success" class="ma-1" @click="model--" :disabled="prev" height="40"
                      min-width="80">
                      <v-icon>mdi-arrow-left-thick</v-icon>
                    </v-btn>
                  </div>

                  <!-- Tombol Tengah -->
                  <div class="d-flex align-center">
                    <v-btn class="font-weight-bold text-none ma-1 ragu-btn"
                      :class="{ 'v-btn--active': getCurrentSoal.ragu }" outlined color="accent" @click="ragu"
                      height="40" min-width="80">
                      Ragu
                    </v-btn>
                    <!-- Tombol Selesai di tengah jika soal terakhir -->
                    <v-btn v-if="model === mapel.soal_count - 1" class="font-weight-bold white--text text-none ma-1"
                      depressed color="red" @click="cekSelesai" height="40" min-width="80">
                      Selesai
                    </v-btn>
                  </div>

                  <!-- Tombol Kanan -->
                  <div class="d-flex align-center">
                    <v-btn depressed color="success" class="ma-1" @click="model++" :disabled="next" height="40"
                      min-width="80">
                      <v-icon>mdi-arrow-right-thick</v-icon>
                    </v-btn>
                  </div>
                </v-layout>
              </v-toolbar>
            </v-card>
          </v-layout>
          <!-- Auto-save indicator -->
          <transition name="fade">
            <div v-if="showAutoSave" class="auto-save-indicator">
              <v-icon small color="success" class="mr-1">mdi-check-circle</v-icon>
              <span class="success--text caption font-weight-medium">Tersimpan</span>
            </div>
          </transition>
          <v-layout row class="lighter-grey--text caption font-weight-thin mt-6 text-center" justify-center>Copyright {{
            new
              Date().getFullYear() }} © Grafindo Media Pratama.
            All Right Reserved.</v-layout>
        </v-flex>
      </v-layout>
      <v-dialog v-model="dialogSoalBelumSelesai" max-width="320">
        <v-card>
          <v-card-title class="display-4">
            <v-layout row justify-center>
              <v-icon x-large color="orange">mdi-alert-circle</v-icon>
            </v-layout>
          </v-card-title>

          <v-card-text class="text-center">
            <div class="mb-3">
              <strong>Masih ada soal yang belum dijawab!</strong>
            </div>
            <div class="caption">
              {{ soalBelumDijawabCount }} dari {{ mapel.soal_count || 0 }} soal
              belum dijawab.
              <br />
              Apakah Anda yakin ingin mengakhiri ujian?
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="orange darken-1" text @click="selesai">
              Ya, Selesai
            </v-btn>

            <v-btn color="green darken-1" text @click="dialogSoalBelumSelesai = false">
              Lanjut Mengerjakan
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog" max-width="290">
        <v-card>
          <v-card-title class="display-4">
            <v-layout row justify-center>
              <v-icon x-large color="red">mdi-alert</v-icon>
            </v-layout>
          </v-card-title>

          <v-card-text>
            Waktu masih tersisa anda yakin mengakhiri ujian?
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="red darken-1" text @click="selesai"> Ya </v-btn>

            <v-btn color="green darken-1" text @click="dialog = false">
              Tidak
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogHabis" persistent max-width="290">
        <v-card>
          <v-card-title class="display-4">
            <v-layout row justify-center>
              <v-icon x-large color="red">mdi-alert</v-icon>
            </v-layout>
          </v-card-title>

          <v-card-text class="text-center"> Waktu sudah habis </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="red darken-1" text to="/hasil"> Hasil </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogKembali" max-width="290">
        <v-card>
          <v-card-title class="display-4">
            <v-layout row justify-center>
              <v-icon x-large color="red">mdi-alert</v-icon>
            </v-layout>
          </v-card-title>

          <v-card-text class="text-center">
            Kamu yakin akan keluar?
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="red darken-1" text :to="'/paket/' + mapel_id">
              Ya
            </v-btn>

            <v-btn color="green darken-1" text @click="dialogKembali = false">
              Tidak
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Loading dialog replaced by skeleton loader -->
    </v-flex>
  </v-container>
</template>

<script>
import * as api from "@/api";
import store from "../store/store";
import MatchingLine from "@/components/MatchingLine.vue";
import PGKategoriComponent from "@/components/PGKategoriComponent.vue";
export default {
  components: {
    MatchingLine,
    PGKategoriComponent,
  },
  data() {
    return {
      loading: false,
      model: 0,
      jawaban: -1,
      toggleRagu: -1,
      drawer: false,
      next: true,
      prev: true,
      progress: 0,
      dialog: false,
      dialogHabis: false,
      dialogKembali: false,
      dialogSoalBelumSelesai: false,
      mapel_id: this.$route.params.id_mapel,
      paket_id: this.$route.params.id_paket,
      huruf: ["A", "B", "C", "D", "E"],
      jawabanTunggalTerpilih: null,
      jawabanKompleksTerpilih: [],
      jawabanPGKategoriTerpilih: {},
      now: Math.trunc(new Date().getTime() / 1000),
      interval: "",
      portrait: this.Window.matchMedia("(orientation: portrait)").matches,
      landscape: this.Window.matchMedia("(orientation: landscape)").matches,
      showAutoSave: false,
      autoSaveTimeout: null,
    };
  },
  methods: {
    saveAnswersToLocalStorage() {
      try {
        const answers = {};
        if (this.mapel.soal && Array.isArray(this.mapel.soal)) {
          this.mapel.soal.forEach((soal, index) => {
            answers[index] = {
              jawab: soal.jawab,
              jawab_huruf: soal.jawab_huruf,
              ragu: soal.ragu || false,
              jawaban_matching: soal.jawaban_matching || null,
            };
          });
        }
        localStorage.setItem(`cbt_answers_${this.paket_id}`, JSON.stringify(answers));
        this.showAutoSaveIndicator();
      } catch (e) {
        // localStorage might be full or unavailable
      }
    },
    restoreAnswersFromLocalStorage() {
      try {
        const saved = localStorage.getItem(`cbt_answers_${this.paket_id}`);
        if (!saved) return false;
        const answers = JSON.parse(saved);
        if (!answers || !this.mapel.soal || !Array.isArray(this.mapel.soal)) return false;
        
        let restored = false;
        this.mapel.soal.forEach((soal, index) => {
          if (answers[index] && (answers[index].jawab !== undefined && answers[index].jawab !== -1 && answers[index].jawab !== '')) {
            this.$set(soal, 'jawab', answers[index].jawab);
            this.$set(soal, 'jawab_huruf', answers[index].jawab_huruf || '');
            if (answers[index].ragu) {
              this.$set(soal, 'ragu', true);
            }
            if (answers[index].jawaban_matching) {
              this.$set(soal, 'jawaban_matching', answers[index].jawaban_matching);
            }
            restored = true;
          }
        });
        
        if (restored) {
          store.commit("updateMapel", this.mapel);
        }
        return restored;
      } catch (e) {
        return false;
      }
    },
    clearSavedAnswers() {
      try {
        localStorage.removeItem(`cbt_answers_${this.paket_id}`);
      } catch (e) {
        // ignore
      }
    },
    showAutoSaveIndicator() {
      this.showAutoSave = true;
      if (this.autoSaveTimeout) {
        clearTimeout(this.autoSaveTimeout);
      }
      this.autoSaveTimeout = setTimeout(() => {
        this.showAutoSave = false;
      }, 2000);
    },
    scrollToTop() {
      // Scroll container utama ke atas
      const container = document.querySelector('.v-container.fill-height');
      if (container) {
        container.scrollTop = 0;
      }

      // Scroll content area ke atas
      const cardText = document.querySelector('.v-card__text');
      if (cardText) {
        cardText.scrollTop = 0;
      }

      // Scroll carousel item ke atas
      const carouselItem = document.querySelector('.v-carousel__item');
      if (carouselItem) {
        carouselItem.scrollTop = 0;
      }

      // Scroll untuk desktop content scroll
      const desktopScrollContent = document.querySelector('.desktop-content-scroll');
      if (desktopScrollContent) {
        desktopScrollContent.scrollTop = 0;
      }

      // Scroll window ke atas untuk mobile
      if (this.$vuetify.breakpoint.smAndDown) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        // Untuk desktop, scroll dengan behavior smooth
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    navigateToSoal(index) {
      this.model = index;
      this.$nextTick(() => {
        this.scrollToTop();
        this.ensureAudioVisibility();
      });
      // Tutup drawer di mobile setelah memilih soal
      if (this.$vuetify.breakpoint.smAndDown) {
        this.drawer = false;
      }
    },
    ensureAudioVisibility() {
      // Pastikan audio element visible di mobile
      this.$nextTick(() => {
        const audioElements = document.querySelectorAll('.soal-audio');
        audioElements.forEach(audio => {
          if (audio) {
            // Force visibility untuk mobile
            audio.style.display = 'block';
            audio.style.visibility = 'visible';
            audio.style.opacity = '1';
            audio.style.position = 'relative';
            audio.style.zIndex = '10';

            // Pastikan audio tidak terpotong oleh overflow
            let parent = audio.parentElement;
            while (parent) {
              if (parent.classList.contains('v-card__text') ||
                parent.classList.contains('soal-content') ||
                parent.classList.contains('v-container')) {
                parent.style.overflow = 'visible';
                break;
              }
              parent = parent.parentElement;
            }
          }
        });
      });
    },
    getMatchingJawaban(soal, leftId) {
      return soal.jawaban_matching ? soal.jawaban_matching[leftId] : null;
    },
    setMatchingJawaban(soal, leftId, selectedRightId) {
      if (!soal.jawaban_matching) {
        this.$set(soal, "jawaban_matching", {});
      }
      this.$set(soal.jawaban_matching, leftId, selectedRightId);
      store.commit("updateMapel", this.mapel);
    },
    onMatchingChange(soal, leftId, selectedRightId) {
      if (!soal.jawaban_matching) {
        this.$set(soal, "jawaban_matching", {});
      }
      this.$set(soal.jawaban_matching, leftId, selectedRightId);
      store.commit("updateMapel", this.mapel);
    },
    getMatchingAnswers(soal) {
      // Konversi dari format array objek {left_id, right_id} ke array index untuk MatchingLine
      const answers = [];
      if (Array.isArray(soal.matching_left)) {
        soal.matching_left.forEach((leftItem, leftIndex) => {
          answers[leftIndex] = [];
          if (Array.isArray(soal.jawab)) {
            soal.jawab.forEach((pair) => {
              if (pair.left_id === leftItem.id) {
                const rightIndex = Array.isArray(soal.matching_right)
                  ? soal.matching_right.findIndex((r) => r.id === pair.right_id)
                  : -1;
                if (rightIndex !== -1) {
                  answers[leftIndex].push(rightIndex);
                }
              }
            });
          }
        });
      }
      return answers;
    },
    updateMatchingAnswers(soal, answers) {
      // Konversi dari format array MatchingLine ke array objek {left_id, right_id}
      const newAnswers = [];
      if (
        Array.isArray(soal.matching_left) &&
        Array.isArray(soal.matching_right) &&
        answers
      ) {
        answers.forEach((rightIndices, leftIndex) => {
          const leftItem = soal.matching_left[leftIndex];
          if (!leftItem) return;
          const leftId = leftItem.id;
          if (Array.isArray(rightIndices) && rightIndices.length > 0) {
            rightIndices.forEach((rightIndex) => {
              const rightItem = soal.matching_right[rightIndex];
              if (rightItem) {
                const rightId = rightItem.id;
                newAnswers.push({ left_id: leftId, right_id: rightId });
              }
            });
          }
        });
      }
      this.$set(soal, "jawab", newAnswers);
      this.$set(soal, "jawab_huruf", newAnswers.length > 0 ? "M" : "");
      store.commit("updateMapel", this.mapel);
      this.saveAnswersToLocalStorage();
      // Update progress jika ada jawaban
      const hasAnswers = newAnswers.length > 0;
      if (hasAnswers && (!soal.jawab_huruf || soal.jawab_huruf === "")) {
        // Sudah di-set di atas
        this.progress =
          (this.mapel.soal.filter((x) => x.jawab_huruf && x.jawab_huruf !== "")
            .length /
            this.mapel.soal_count) *
          100;
      } else if (!hasAnswers && soal.jawab_huruf && soal.jawab_huruf !== "") {
        this.$set(soal, "jawab_huruf", "");
        this.progress =
          (this.mapel.soal.filter((x) => x.jawab_huruf && x.jawab_huruf !== "")
            .length /
            this.mapel.soal_count) *
          100;
      }
    },
    getPGKategoriAnswers(soal) {
      // Mengembalikan jawaban PG kategori yang tersimpan
      return soal.jawab && typeof soal.jawab === "object" ? soal.jawab : {};
    },
    updatePGKategoriAnswers(soal, answers) {
      // Update jawaban PG kategori
      this.$set(soal, "jawab", answers);

      // Generate huruf jawaban (untuk tracking di lembar jawaban)
      const hasAnswers = Object.keys(answers).length > 0;
      this.$set(soal, "jawab_huruf", hasAnswers ? "PGK" : "");

      store.commit("updateMapel", this.mapel);
      this.saveAnswersToLocalStorage();

      // Update progress
      this.progress =
        (this.mapel.soal.filter((x) => x.jawab_huruf && x.jawab_huruf !== "")
          .length /
          this.mapel.soal_count) *
        100;
    },
    selesai() {
      this.loading = true;
      this.clearSavedAnswers();
      this.mapel.elapsedTime =
        this.$options.filters.two_digits(this.hoursElapsed) +
        ":" +
        this.$options.filters.two_digits(this.minutesElapsed) +
        ":" +
        this.$options.filters.two_digits(this.secondsElapsed);
      const now = new Date();
      const jam = now.getHours().toString().padStart(2, "0");
      const menit = now.getMinutes().toString().padStart(2, "0");
      this.mapel.waktu_pelaksanaan = `${jam}.${menit}`;
      store.commit("updateMapel", this.mapel);
      clearInterval(this.interval);
      setTimeout(() => {
        this.$router.push("/hasil");
      }, 1000);
    },
    cekSelesai() {
      // Cek apakah ada soal yang belum dijawab
      const soalBelumDijawab = this.mapel.soal.filter(
        (soal) =>
          !soal.jawab_huruf || soal.jawab_huruf === "" || soal.jawab === -1
      );

      if (soalBelumDijawab.length > 0) {
        // Jika ada soal yang belum dijawab, tampilkan dialog peringatan khusus
        this.dialogSoalBelumSelesai = true;
      } else {
        // Jika semua soal sudah dijawab, tampilkan dialog konfirmasi normal
        this.dialog = true;
      }
    },
    async get() {
      this.loading = true;

      // CLEAR INTERVAL TIMER SEBELUMNYA UNTUK MENCEGAH BUG WAKTU
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }

      if (Object.keys(this.mapel).length === 0) {
        await api.get(
          "/mapel/" + this.mapel_id + "/paket/" + this.paket_id + "/soal",
          {},
          async (res) => {
            if (res.status) {
              store.commit("updateMapel", res.data);
              var date = new Date();
              this.now = Math.trunc(date.getTime() / 1000);
              date.setMinutes(date.getMinutes() + this.mapel.waktu);

              this.mapel.start = this.now;
              this.mapel.target = Math.trunc(date.getTime() / 1000);
              store.commit("updateMapel", this.mapel);
              this.startSoal();
            }
          }
        );
      }
      if (Object.keys(this.mapel).length > 0) {
        this.startSoal();
      }
    },
    pilihJawaban(id, huruf) {
      var _id = -1;
      var _huruf = "";
      if (this.mapel.soal[this.model].jawab != id) {
        _id = id;
        _huruf = huruf;
      }
      this.$set(this.mapel.soal[this.model], "jawab", _id);
      this.$set(this.mapel.soal[this.model], "jawab_huruf", _huruf);
      this.progress =
        (this.mapel.soal.filter((x) => x.jawab && x.jawab != -1).length /
          this.mapel.soal_count) *
        100;
      store.commit("updateMapel", this.mapel);
      this.saveAnswersToLocalStorage();
    },
    pilihJawabanTunggal(id) {
      const currentAnswer = this.jawabanTunggalTerpilih;
      if (currentAnswer === id) {
        // Jika pilihan yang sama diklik lagi, batalkan pilihan
        this.jawabanTunggalTerpilih = null;
        this.$set(this.mapel.soal[this.model], "jawab", -1);
        this.$set(this.mapel.soal[this.model], "jawab_huruf", "");
      } else {
        this.jawabanTunggalTerpilih = id;
        // Cari index pilihan untuk mendapatkan huruf
        const pilihanArr = this.mapel.soal[this.model].pilihan_jawaban;
        const pilihanIndex = Array.isArray(pilihanArr)
          ? pilihanArr.findIndex((p) => p.id === id)
          : -1;
        const huruf = this.huruf[pilihanIndex] || "";
        this.$set(this.mapel.soal[this.model], "jawab", id);
        this.$set(this.mapel.soal[this.model], "jawab_huruf", huruf);
      }
      this.progress =
        (this.mapel.soal.filter((x) => x.jawab && x.jawab != -1).length /
          this.mapel.soal_count) *
        100;
      store.commit("updateMapel", this.mapel);
      this.saveAnswersToLocalStorage();
    },
    toggleJawabanKompleks(id) {
      const currentAnswers = [...this.jawabanKompleksTerpilih];
      const index = currentAnswers.indexOf(id);

      if (index > -1) {
        // Hapus dari pilihan jika sudah ada
        currentAnswers.splice(index, 1);
      } else {
        // Tambah ke pilihan jika belum ada
        currentAnswers.push(id);
      }

      this.jawabanKompleksTerpilih = currentAnswers;

      // Set jawaban ke dalam mapel state
      this.$set(
        this.mapel.soal[this.model],
        "jawab",
        currentAnswers.length > 0 ? currentAnswers : -1
      );

      // Generate huruf untuk jawaban yang dipilih
      const pilihanArr = this.mapel.soal[this.model].pilihan_jawaban;
      const hurufTerpilih = currentAnswers
        .map((jawabanId) => {
          const pilihan = Array.isArray(pilihanArr)
            ? pilihanArr.find((p) => p.id === jawabanId)
            : null;
          if (pilihan) {
            const pilihanIndex = pilihanArr.indexOf(pilihan);
            return this.huruf[pilihanIndex] || "";
          }
          return "";
        })
        .filter((h) => h)
        .sort();

      this.$set(
        this.mapel.soal[this.model],
        "jawab_huruf",
        hurufTerpilih.join(", ")
      );
      this.progress =
        (this.mapel.soal.filter((x) => x.jawab && x.jawab != -1).length /
          this.mapel.soal_count) *
        100;
      store.commit("updateMapel", this.mapel);
      this.saveAnswersToLocalStorage();
    },
    getHurufByPilihanId(pilihanId) {
      const pilihanArr = this.mapel.soal[this.model].pilihan_jawaban;
      const pilihanIndex = Array.isArray(pilihanArr)
        ? pilihanArr.findIndex((p) => p.id === pilihanId)
        : -1;
      return this.huruf[pilihanIndex] || "";
    },
    handleKeyboardShortcut(event) {
      // Don't interfere with text input fields
      const tagName = event.target.tagName;
      if (tagName === 'INPUT' || tagName === 'TEXTAREA' || tagName === 'SELECT' || event.target.isContentEditable) {
        return;
      }

      // Don't trigger if any dialog is open
      if (this.dialog || this.dialogHabis || this.dialogKembali || this.dialogSoalBelumSelesai) {
        return;
      }

      // Don't trigger if still loading
      if (this.loading) return;

      // Don't trigger if mapel or soal is not ready
      if (!this.mapel.soal || !this.mapel.soal.length) return;

      const totalSoal = this.mapel.soal_count || this.mapel.soal.length;

      switch (event.key) {
        case 'ArrowLeft':
          event.preventDefault();
          if (event.ctrlKey) {
            // Ctrl+Arrow Left: Jump 5 questions back
            const targetGroup = Math.max(0, this.model - 5);
            this.model = targetGroup;
          } else {
            // Arrow Left: Previous question
            if (this.model > 0) {
              this.model--;
            }
          }
          break;

        case 'ArrowRight':
          event.preventDefault();
          if (event.ctrlKey) {
            // Ctrl+Arrow Right: Jump 5 questions forward
            const targetGroup = Math.min(totalSoal - 1, this.model + 5);
            this.model = targetGroup;
          } else {
            // Arrow Right: Next question
            if (this.model < totalSoal - 1) {
              this.model++;
            }
          }
          break;

        case ' ':
          // Space: Toggle ragu flag
          if (event.target.type !== 'button' && event.target.type !== 'submit') {
            event.preventDefault();
            this.ragu();
          }
          break;

        default:
          // Number keys 1-9: Jump to question number
          if (event.key >= '1' && event.key <= '9' && !event.ctrlKey && !event.altKey && !event.metaKey) {
            const targetIndex = parseInt(event.key) - 1;
            if (targetIndex < totalSoal) {
              this.model = targetIndex;
            }
          }
          break;
      }
    },
    toggleDrawer() {
      this.drawer = !this.drawer;
      // Force update untuk memastikan drawer muncul di mobile
      if (this.$vuetify.breakpoint.smAndDown && this.drawer) {
        this.$nextTick(() => {
          // Pastikan overlay dan z-index tepat
          const drawerElement = document.querySelector(".v-navigation-drawer");
          if (drawerElement) {
            drawerElement.style.zIndex = "2000";
          }
        });
      }
    },
    ragu() {
      var ragu = false;
      if (!this.mapel.soal[this.model].ragu) {
        ragu = true;
      }
      this.$set(this.mapel.soal[this.model], "ragu", ragu);
      store.commit("updateMapel", this.mapel);
      this.saveAnswersToLocalStorage();
    },
    startSoal() {
      if (this.mapel.soal_count > 1) this.next = false;

      // CLEAR INTERVAL TIMER SEBELUMNYA UNTUK MENCEGAH BUG WAKTU
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }

      if (this.now >= this.target) {
        this.dialogHabis = true;
        this.mapel.elapsedTime =
          this.$options.filters.two_digits(this.hoursElapsed) +
          ":" +
          this.$options.filters.two_digits(this.minutesElapsed) +
          ":" +
          this.$options.filters.two_digits(this.secondsElapsed);
        store.commit("updateMapel", this.mapel);
      } else {
        this.interval = setInterval(() => {
          this.now = Math.trunc(new Date().getTime() / 1000);
          if (this.now >= this.target) {
            this.dialogHabis = true;
            clearInterval(this.interval);
            this.mapel.elapsedTime =
              this.$options.filters.two_digits(this.hoursElapsed) +
              ":" +
              this.$options.filters.two_digits(this.minutesElapsed) +
              ":" +
              this.$options.filters.two_digits(this.secondsElapsed);
            store.commit("updateMapel", this.mapel);
          }
        }, 1000);
      }
      this.progress =
        (this.mapel.soal.filter((x) => x.jawab && x.jawab != -1).length /
          this.mapel.soal_count) *
        100;
      store.commit("updateMapel", this.mapel);
      
      // Restore saved answers from localStorage
      this.restoreAnswersFromLocalStorage();
      
      // Recalculate progress after restore
      this.progress =
        (this.mapel.soal.filter((x) => x.jawab_huruf && x.jawab_huruf !== "" && x.jawab !== -1).length /
          this.mapel.soal_count) *
        100;

      this.loading = false;

      // Pastikan audio visible setelah soal loaded
      this.$nextTick(() => {
        this.ensureAudioVisibility();
      });
    },
  },
  computed: {
    toolbarClasses() {
      const classes = [];
      if (this.$vuetify.breakpoint.mdAndUp) {
        classes.push("px-5");
      } else {
        classes.push("px-2", "toolbar-sticky");
        if (this.portrait) {
          classes.push("pt-4");
        }
        if (this.landscape) {
          classes.push("mobile-landscape-toolbar");
        }
      }
      return classes;
    },
    toolbarHeight() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return this.landscape ? 68 : 56;
      }
      return 64;
    },
    getCurrentSoal() {
      return this.mapel.soal && this.mapel.soal[this.model]
        ? this.mapel.soal[this.model]
        : {};
    },
    soalBelumDijawabCount() {
      if (!this.mapel.soal || !Array.isArray(this.mapel.soal)) return 0;
      return this.mapel.soal.filter(
        (soal) =>
          !soal.jawab_huruf || soal.jawab_huruf === "" || soal.jawab === -1
      ).length;
    },
    answeredCount() {
      if (!this.mapel.soal || !Array.isArray(this.mapel.soal)) return 0;
      return this.mapel.soal.filter(
        (soal) =>
          soal.jawab_huruf && soal.jawab_huruf !== "" && soal.jawab !== -1
      ).length;
    },
    answeredPercentage() {
      const total = this.mapel.soal_count || 0;
      if (total === 0) return 0;
      return Math.round((this.answeredCount / total) * 100);
    },
    getFontSetting() {
      return (
        "font-family:" +
        this.mapel.font_family +
        "; " +
        // Hapus font-size, biarkan CSS responsive yang mengatur ukuran font
        ""
      );
    },
    getCarouselHeight() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return 'calc(70vh - 120px)';
      } else if (this.$vuetify.breakpoint.lgAndUp) {
        // For large desktop, use reasonable height without requiring scroll
        return 'calc(85vh - 140px)';
      } else if (this.$vuetify.breakpoint.mdAndUp) {
        // For medium desktop/tablet - check for limited height screens like 1366x768
        const screenHeight = window.innerHeight || 768;
        if (screenHeight <= 800) {
          // For screens with limited height (like 1366x768) - more conservative
          return 'calc(70vh - 120px)';
        }
        // For taller medium screens
        return 'calc(75vh - 120px)';
      }
      return '600px'; // fallback
    },
    seconds() {
      return (this.target - this.now) % 60;
    },

    minutes() {
      return Math.trunc((this.target - this.now) / 60) % 60;
    },

    hours() {
      return Math.trunc((this.target - this.now) / 60 / 60) % 24;
    },

    days() {
      return Math.trunc((this.target - this.now) / 60 / 60 / 24);
    },
    secondsElapsed() {
      return (this.now - this.start) % 60;
    },

    minutesElapsed() {
      return Math.trunc((this.now - this.start) / 60) % 60;
    },

    hoursElapsed() {
      return Math.trunc((this.now - this.start) / 60 / 60) % 24;
    },

    daysElapsed() {
      return Math.trunc((this.now - this.start) / 60 / 60 / 24);
    },
    mapel() {
      return store.state.mapel;
    },
    target() {
      return store.state.mapel.target;
    },
    start() {
      return store.state.mapel.start;
    },
  },
  mounted() {
    window.onbeforeunload = function () {
      clearInterval(this.interval);
    };
    let _this = this;
    var mql = this.Window.matchMedia("(orientation: portrait)");
    mql.addListener(function (e) {
      if (e.matches) {
        _this.portrait = true;
        _this.landscape = false;
      } else {
        _this.portrait = false;
        _this.landscape = true;
      }
    }, false);
    
    // Fix 23: Add resize listener for orientation detection
    this._orientationHandler = function() {
      const isPortrait = window.matchMedia("(orientation: portrait)").matches;
      _this.portrait = isPortrait;
      _this.landscape = !isPortrait;
    };
    window.addEventListener('resize', this._orientationHandler);
    
    this.get();

    // Fix 21: Register keyboard shortcuts
    window.addEventListener('keydown', this.handleKeyboardShortcut);

    if (Object.keys(this.mapel).length > 0) {
      this.jawaban = this.mapel.soal[this.model].jawab;
      this.toggleRagu = this.mapel.soal[this.model].ragu ? 0 : -1;
      this.progress = ((this.model + 1) / this.mapel.soal_count) * 100;

      // Initialize jawaban terpilih berdasarkan tipe soal
      const currentSoal = this.mapel.soal[this.model];
      if (currentSoal.tipe_soal === "pilihan_ganda_kompleks") {
        this.jawabanKompleksTerpilih = Array.isArray(currentSoal.jawab)
          ? currentSoal.jawab
          : [];
      } else if (currentSoal.tipe_soal === "pg_kategori") {
        this.jawabanPGKategoriTerpilih =
          typeof currentSoal.jawab === "object" && currentSoal.jawab !== null
            ? currentSoal.jawab
            : {};
      } else {
        this.jawabanTunggalTerpilih =
          currentSoal.jawab && currentSoal.jawab !== -1
            ? currentSoal.jawab
            : null;
      }
    }

    // Pastikan audio visibility setelah component mounted
    this.$nextTick(() => {
      this.ensureAudioVisibility();
    });

  },
  beforeDestroy() {
    // PASTIKAN CLEAR INTERVAL SAAT COMPONENT DESTROY
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
    // Clear auto-save timeout
    if (this.autoSaveTimeout) {
      clearTimeout(this.autoSaveTimeout);
      this.autoSaveTimeout = null;
    }
    // Remove orientation/resize listeners
    if (this._orientationHandler) {
      window.removeEventListener('resize', this._orientationHandler);
    }
    // Fix 21: Remove keyboard shortcuts listener
    window.removeEventListener('keydown', this.handleKeyboardShortcut);
  },
  watch: {
    model(index) {
      // Scroll ke atas setiap pindah soal
      this.$nextTick(() => {
        this.scrollToTop();
        this.ensureAudioVisibility();
      });

      // Pastikan audio berhenti setelah DOM update
      this.$nextTick(() => {
        const audioRefs = this.$refs.audioPlayer;
        if (audioRefs) {
          if (Array.isArray(audioRefs)) {
            audioRefs.forEach((a) => {
              if (a && typeof a.pause === "function") {
                try {
                  a.pause();
                  a.currentTime = 0;
                } catch (e) {
                  /* audio stop error */
                }
              }
            });
          } else if (typeof audioRefs.pause === "function") {
            try {
              audioRefs.pause();
              audioRefs.currentTime = 0;
            } catch (e) {
              /* audio stop error */
            }
          }
        }
      });
      if (index == this.mapel.soal_count - 1) {
        this.next = true;
        this.prev = false;
      } else if (index == 0) {
        this.prev = true;
        this.next = false;
      } else {
        this.next = false;
        this.prev = false;
      }
      this.jawaban = this.mapel.soal[index].jawab;
      this.toggleRagu = this.mapel.soal[index].ragu ? 0 : -1;

      // Update jawaban terpilih ketika berganti soal
      const currentSoal = this.mapel.soal[index];
      if (currentSoal.tipe_soal === "pilihan_ganda_kompleks") {
        this.jawabanKompleksTerpilih = Array.isArray(currentSoal.jawab)
          ? currentSoal.jawab
          : [];
        this.jawabanTunggalTerpilih = null;
        this.jawabanPGKategoriTerpilih = {};
      } else if (currentSoal.tipe_soal === "pg_kategori") {
        this.jawabanPGKategoriTerpilih =
          typeof currentSoal.jawab === "object" && currentSoal.jawab !== null
            ? currentSoal.jawab
            : {};
        this.jawabanTunggalTerpilih = null;
        this.jawabanKompleksTerpilih = [];
      } else {
        this.jawabanTunggalTerpilih =
          currentSoal.jawab && currentSoal.jawab !== -1
            ? currentSoal.jawab
            : null;
        this.jawabanKompleksTerpilih = [];
        this.jawabanPGKategoriTerpilih = {};
      }
    },
    gantiSoal(index) {
      // Scroll ke atas setiap pindah soal
      this.$nextTick(() => {
        this.scrollToTop();
      });

      this.model = index;
      if (index == this.mapel.soal_count - 1) {
        this.next = true;
        this.prev = false;
      } else if (index == 0) {
        this.prev = true;
        this.next = false;
      } else {
        this.next = false;
        this.prev = false;
      }
      this.jawaban = this.mapel.soal[index].jawab;
      this.toggleRagu = this.mapel.soal[index].ragu ? 0 : -1;

      // Update jawaban terpilih ketika berganti soal
      const currentSoal = this.mapel.soal[index];
      if (currentSoal.tipe_soal === "pilihan_ganda_kompleks") {
        this.jawabanKompleksTerpilih = Array.isArray(currentSoal.jawab)
          ? currentSoal.jawab
          : [];
        this.jawabanTunggalTerpilih = null;
        this.jawabanPGKategoriTerpilih = {};
      } else if (currentSoal.tipe_soal === "pg_kategori") {
        this.jawabanPGKategoriTerpilih =
          typeof currentSoal.jawab === "object" && currentSoal.jawab !== null
            ? currentSoal.jawab
            : {};
        this.jawabanTunggalTerpilih = null;
        this.jawabanKompleksTerpilih = [];
      } else {
        this.jawabanTunggalTerpilih =
          currentSoal.jawab && currentSoal.jawab !== -1
            ? currentSoal.jawab
            : null;
        this.jawabanKompleksTerpilih = [];
        this.jawabanPGKategoriTerpilih = {};
      }
    },
  },
};
</script>

<style scoped>
.answer-btn {
  border: thin solid rgba(0, 0, 0, 0.12) !important;
  /* border-radius: inherit !important; */
}

.ragu-btn.v-btn--active {
  background-color: #fec74e !important;
  color: #fff !important;
}

/* Tombol Ragu - styling untuk state off (tidak aktif) */
.ragu-btn:not(.v-btn--active) {
  background-color: #fff !important;
  color: #fec74e !important;
  border: thin solid rgba(0, 0, 0, 0.12) !important;
}

.flex>.answer-btn.v-btn--active {
  background-color: #6388fa !important;
  color: white !important;
}

.layout>.answer-btn.v-btn--active {
  background-color: #6388fa !important;
  color: white !important;
}

/* Area konten yang bisa scroll horizontal untuk tipe soal tertentu */
.horizontal-scrollable-content {
  overflow-x: auto !important;
  overflow-y: visible !important;
  width: 100% !important;
  min-width: 100% !important;
}

/* Pastikan component di dalam bisa melebar */
.horizontal-scrollable-content>* {
  max-width: none !important;
  width: auto !important;
}

/* CSS khusus untuk MatchingLine component di mobile */
@media (max-width: 768px) {

  .horizontal-scrollable-content .matching-container,
  .horizontal-scrollable-content .matching-line-component {
    min-width: 600px !important;
    /* Minimum width untuk matching */
    width: auto !important;
    overflow: visible !important;
  }
}

/* Toolbar sticky untuk mobile */
.toolbar-sticky {
  position: sticky !important;
  top: 0 !important;
  z-index: 10 !important;
  background-color: #1976d2 !important;
}

/* Back button positioning */
.btn-kembali {
  position: relative;
  margin-bottom: 20px !important;
  margin-top: 25px !important;
}

/* Desktop answer button styling */
.desktop-answer-btn {
  min-height: 40px !important;
  min-width: 140px !important;
  padding: 0 20px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  transition: all 0.2s ease !important;
  touch-action: manipulation !important;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1) !important;
  border-radius: 4px !important;
}

.desktop-answer-btn:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  transform: translateY(-1px) !important;
}

.desktop-answer-btn:active {
  transform: scale(0.98) !important;
}

/* Prevent button from going under sticky toolbar */
@media (max-width: 768px) and (orientation: landscape) {
  .btn-kembali {
    margin-top: 80px !important;
    margin-bottom: 8px !important;
    height: 32px !important;
    min-width: 80px !important;
    font-size: 12px !important;
    padding: 0 12px !important;
  }

  .btn-kembali .v-icon {
    font-size: 16px !important;
    margin-right: 4px !important;
  }
}

/* Additional optimization for very small landscape screens */
@media (max-width: 600px) and (orientation: landscape) {
  .btn-kembali {
    margin-top: 70px !important;
    margin-bottom: 6px !important;
    height: 28px !important;
    min-width: 70px !important;
    font-size: 11px !important;
    padding: 0 8px !important;
  }

  .btn-kembali .v-icon {
    font-size: 14px !important;
    margin-right: 2px !important;
  }

  /* Floating back button untuk landscape sangat kecil */
  .landscape-floating-btn {
    position: fixed !important;
    top: 76px !important;
    left: 8px !important;
    z-index: 100 !important;
    margin: 0 !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2) !important;
  }
}

/* Icon-only button untuk landscape yang sangat sempit */
@media (max-width: 480px) and (orientation: landscape) {
  .landscape-floating-btn {
    min-width: 40px !important;
    width: 40px !important;
    height: 40px !important;
    border-radius: 50% !important;
    padding: 0 !important;
    top: 72px !important;
    left: 6px !important;
  }

  .landscape-floating-btn .v-btn__content {
    flex-direction: column !important;
  }

  .landscape-floating-btn .v-icon {
    margin: 0 !important;
    font-size: 18px !important;
  }

  /* Hide text, show only icon */
  .landscape-floating-btn .v-btn__content>span:not(.v-icon) {
    display: none !important;
  }
}

/* Floating Answer Sheet Button for Landscape */
.landscape-floating-answer-btn {
  position: fixed !important;
  top: 76px !important;
  right: 8px !important;
  z-index: 100 !important;
  margin: 0 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25) !important;
  min-width: 80px !important;
  height: 36px !important;
  padding: 0 12px !important;
  border-radius: 18px !important;
  touch-action: manipulation !important;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1) !important;
  user-select: none !important;
  transition: all 0.2s ease !important;
}

.landscape-floating-answer-btn:active {
  transform: scale(0.95) !important;
  opacity: 0.8 !important;
}

.landscape-floating-answer-btn:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3) !important;
  transform: translateY(-1px) !important;
}

/* Adjust positioning to not overlap with back button */
@media (max-width: 768px) and (orientation: landscape) {
  .landscape-floating-answer-btn {
    top: 80px !important;
    right: 8px !important;
    min-width: 90px !important;
    height: 40px !important;
  }
}

@media (max-width: 600px) and (orientation: landscape) {
  .landscape-floating-answer-btn {
    top: 72px !important;
    right: 6px !important;
    height: 36px !important;
    min-width: 80px !important;
    font-size: 11px !important;
    padding: 0 10px !important;
  }
}

@media (max-width: 480px) and (orientation: landscape) {
  .landscape-floating-answer-btn {
    top: 72px !important;
    right: 54px !important;
    /* Position next to back button */
    width: 48px !important;
    height: 48px !important;
    border-radius: 24px !important;
    padding: 0 !important;
    min-width: 48px !important;
  }

  .landscape-floating-answer-btn .v-icon {
    margin: 0 !important;
    font-size: 20px !important;
  }

  /* Ensure both floating buttons are aligned */
  .landscape-floating-btn {
    left: 6px !important;
  }
}

/* For very small screens, position buttons side by side */
@media (max-width: 400px) and (orientation: landscape) {
  .landscape-floating-answer-btn {
    right: 50px !important;
    width: 44px !important;
    height: 44px !important;
  }

  .landscape-floating-answer-btn .v-icon {
    font-size: 18px !important;
  }
}

/* Floating Timer for Landscape */
.landscape-floating-timer {
  position: fixed !important;
  top: 76px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  z-index: 100 !important;
  background: rgba(25, 118, 210, 0.9) !important;
  color: white !important;
  padding: 0 12px !important;
  border-radius: 18px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2) !important;
  display: flex !important;
  align-items: center !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  min-width: 80px !important;
  height: 36px !important;
  backdrop-filter: blur(10px) !important;
}

@media (max-width: 600px) and (orientation: landscape) {
  .landscape-floating-timer {
    top: 72px !important;
    padding: 0 8px !important;
    font-size: 11px !important;
    min-width: 70px !important;
    height: 32px !important;
  }

  .landscape-floating-timer .v-icon {
    font-size: 14px !important;
  }
}

@media (max-width: 480px) and (orientation: landscape) {
  .landscape-floating-timer {
    top: 72px !important;
    padding: 0 6px !important;
    font-size: 10px !important;
    border-radius: 16px !important;
    min-width: 60px !important;
    height: 28px !important;
  }

  .landscape-floating-timer .v-icon {
    font-size: 12px !important;
    margin-right: 2px !important;
  }
}

/* Floating Timer for Portrait */
.portrait-floating-timer {
  position: fixed !important;
  top: 76px !important;
  right: 120px !important;
  z-index: 100 !important;
  background: rgba(25, 118, 210, 0.9) !important;
  color: white !important;
  padding: 0 12px !important;
  border-radius: 18px !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  display: flex !important;
  align-items: center !important;
  min-width: 80px !important;
  height: 36px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
}

.portrait-floating-timer .v-icon {
  color: white !important;
  font-size: 16px !important;
  margin-right: 4px !important;
}

/* Floating Answer Sheet Button for Portrait */
.portrait-floating-answer-btn {
  position: fixed !important;
  top: 76px !important;
  right: 8px !important;
  z-index: 1000 !important;
  margin: 0 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25) !important;
  min-width: 80px !important;
  height: 36px !important;
  padding: 0 12px !important;
  border-radius: 18px !important;
  touch-action: manipulation !important;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1) !important;
  user-select: none !important;
  transition: all 0.2s ease !important;
}

.portrait-floating-answer-btn:active {
  transform: scale(0.95) !important;
  opacity: 0.8 !important;
}

.portrait-floating-answer-btn:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3) !important;
  transform: translateY(-2px) !important;
}

/* Responsive adjustments for portrait floating elements */
@media (max-width: 360px) and (orientation: portrait) {
  .portrait-floating-timer {
    top: 72px !important;
    right: 100px !important;
    padding: 0 8px !important;
    font-size: 11px !important;
    border-radius: 16px !important;
    min-width: 70px !important;
    height: 32px !important;
  }

  .portrait-floating-timer .v-icon {
    font-size: 14px !important;
    margin-right: 3px !important;
  }

  .portrait-floating-answer-btn {
    top: 72px !important;
    right: 6px !important;
    min-width: 70px !important;
    height: 32px !important;
    font-size: 11px !important;
    padding: 0 8px !important;
    border-radius: 16px !important;
  }
}

/* Carousel dengan header sticky */
.carousel-with-sticky-header {
  margin-top: 0 !important;
}

/* Adjust card margin when using floating back button */
@media (max-width: 768px) and (orientation: landscape) {
  .landscape-floating-btn~.v-card {
    margin-left: 0 !important;
    margin-top: 0 !important;
  }

  /* Ensure main content doesn't overlap with floating buttons */
  .v-flex.xs10.xl8 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}

/* V-card adjustments untuk sticky toolbar */
@media (max-width: 768px) {
  .v-card {
    position: relative !important;
  }

  .v-card .v-toolbar {
    position: sticky !important;
    top: 0 !important;
    z-index: 50 !important;
  }
}

.device-height {
  height: 70vh;
}

.desktop-full-height {
  min-height: calc(85vh - 120px);
  max-height: calc(90vh - 100px);
  height: auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.desktop-container {
  min-height: calc(80vh - 180px);
  max-height: calc(85vh - 150px);
  padding: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.desktop-content-scroll {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(85vh - 200px);
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
}

.desktop-content-scroll::-webkit-scrollbar {
  width: 6px;
}

.desktop-content-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.desktop-content-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.desktop-content-scroll::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.3);
}

/* Hide scrollbars on main containers */
.v-carousel,
.v-carousel__item,
.desktop-container {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.v-carousel::-webkit-scrollbar,
.v-carousel__item::-webkit-scrollbar,
.desktop-container::-webkit-scrollbar {
  display: none;
}

/* Optimize desktop layout */
@media (min-width: 960px) {
  .v-carousel {
    max-height: calc(85vh - 140px) !important;
    min-height: calc(75vh - 120px) !important;
    overflow: hidden !important;
  }

  .v-carousel__item {
    max-height: calc(85vh - 140px) !important;
    min-height: calc(75vh - 120px) !important;
    overflow: hidden !important;
  }

  /* Ensure soal content gets proper spacing but not too much */
  .soal-content {
    min-height: 150px;
    max-height: none;
    margin-bottom: 16px;
  }

  /* Make pilihan container more compact */
  .pilihan-container {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .pilihan-item {
    margin-bottom: 12px;
    padding: 16px;
    min-height: 70px;
  }

  /* Desktop actions styling - more compact */
  .desktop-actions {
    padding: 16px 24px !important;
    margin-top: 12px;
    flex-shrink: 0;
  }

  .desktop-actions .v-btn {
    min-height: 44px;
    padding: 0 20px;
  }

  /* General desktop card actions with better spacing control */
  .v-card-actions[class*="pa-5"] {
    padding: 16px 20px !important;
    flex-shrink: 0 !important;
    min-height: 80px !important;
    max-height: 100px !important;
  }

  /* Ensure actions don't take too much space */
  .v-card-actions .v-layout {
    min-height: 60px !important;
    align-items: center !important;
  }

  /* Prevent card from overflowing viewport */
  .desktop-full-height {
    max-height: calc(90vh - 60px) !important;
    height: auto !important;
    overflow: visible !important;
    display: flex !important;
    flex-direction: column !important;
  }

  /* Card content should be scrollable, actions should be fixed */
  .desktop-container {
    flex: 1 !important;
    overflow-y: auto !important;
    max-height: calc(80vh - 140px) !important;
  }

  /* Ensure actions area is always visible */
  .v-card-actions {
    flex-shrink: 0 !important;
    display: flex !important;
    visibility: visible !important;
    opacity: 1 !important;
    position: relative !important;
    z-index: 10 !important;
    background: white !important;
    border-top: 1px solid #e0e0e0 !important;
  }

  /* Force button visibility for all desktop breakpoints */
  .v-card-actions .v-btn {
    display: inline-flex !important;
    visibility: visible !important;
    opacity: 1 !important;
    position: relative !important;
    z-index: 1 !important;
  }

  /* Ensure layout containers don't hide buttons */
  .v-card-actions .v-layout,
  .v-card-actions .d-flex {
    display: flex !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
}

/* For very large screens, limit the height more aggressively */
@media (min-width: 1440px) {
  .v-carousel {
    max-height: calc(80vh - 120px) !important;
    min-height: calc(70vh - 100px) !important;
    overflow: hidden !important;
  }

  .v-carousel__item {
    max-height: calc(80vh - 120px) !important;
    min-height: calc(70vh - 100px) !important;
    overflow: hidden !important;
  }

  .desktop-full-height {
    max-height: calc(82vh - 100px);
  }

  .desktop-container {
    max-height: calc(78vh - 130px);
  }

  .desktop-content-scroll {
    max-height: calc(78vh - 180px);
  }
}

/* Specific fix for 1366x768 and similar medium desktop resolutions with limited height */
@media (min-width: 960px) and (max-width: 1439px) and (max-height: 800px) {
  .v-carousel {
    max-height: calc(70vh - 100px) !important;
    min-height: calc(60vh - 80px) !important;
    overflow: hidden !important;
  }

  .v-carousel__item {
    max-height: calc(70vh - 100px) !important;
    min-height: calc(60vh - 80px) !important;
    overflow: hidden !important;
  }

  .desktop-full-height {
    max-height: calc(85vh - 80px) !important;
    min-height: calc(75vh - 60px) !important;
  }

  .desktop-container {
    max-height: calc(70vh - 120px) !important;
    min-height: calc(60vh - 100px) !important;
    padding: 16px !important;
  }

  .desktop-content-scroll {
    max-height: calc(65vh - 140px) !important;
  }

  /* Ensure card actions are visible and properly spaced */
  .v-card-actions {
    padding: 12px 20px !important;
    margin-top: 8px !important;
    display: flex !important;
    visibility: visible !important;
    opacity: 1 !important;
    position: relative !important;
    z-index: 10 !important;
  }

  .v-card-actions .v-btn {
    min-height: 40px !important;
    padding: 0 16px !important;
    display: inline-flex !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
}

/* Additional fix for exactly 1366x768 resolution */
@media (min-width: 1360px) and (max-width: 1370px) and (max-height: 775px) {
  .v-carousel {
    max-height: calc(68vh - 90px) !important;
    min-height: calc(58vh - 70px) !important;
  }

  .v-carousel__item {
    max-height: calc(68vh - 90px) !important;
    min-height: calc(58vh - 70px) !important;
  }

  .desktop-full-height {
    max-height: calc(82vh - 70px) !important;
    min-height: calc(72vh - 50px) !important;
  }

  .desktop-container {
    max-height: calc(68vh - 110px) !important;
    padding: 12px !important;
  }

  .desktop-content-scroll {
    max-height: calc(63vh - 130px) !important;
  }

  /* Ensure actions remain visible for 1366x768 */
  .v-card-actions {
    padding: 10px 16px !important;
    margin-top: 6px !important;
    display: flex !important;
    visibility: visible !important;
    opacity: 1 !important;
    position: relative !important;
    z-index: 10 !important;
    background: white !important;
  }

  .v-card-actions .v-btn {
    min-height: 38px !important;
    padding: 0 14px !important;
    display: inline-flex !important;
    visibility: visible !important;
    opacity: 1 !important;
  }

  .v-card-actions .mr-3 {
    margin-right: 8px !important;
  }
}

.device-height-50 {
  height: 70vh;
}

.device-height-60 {
  height: 80vh;
}

.v-toolbar--bottom {
  display: flex;
  justify-content: center;
}

.boxed-option {
  border: 1px solid black;
  padding: 10px;
  margin: 5px 0px;
}

/* Instruction Box */
.instruction-box {
  background-color: #d1ecf1;
  border: 1px solid #bee5eb;
  border-radius: 5px;
  padding: 15px;
  margin-bottom: 20px;
}

.instruction-text {
  margin: 0;
  color: #0c5460;
  font-size: 14px;
  text-align: center;
  line-height: 1.5;
}

/* Fixed Nomor Soal di Paling Atas */
.fixed-soal-number {
  position: fixed;
  top: 120px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  padding: 8px 20px;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
}

.soal-number-display {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
  color: #1976d2;
}

/* New CSS for custom pilihan display */
.pilihan-container {
  margin-top: 20px;
  padding-top: 20px;
  /* Space for fixed header */
  padding-bottom: 20px;
  /* Minimal space for scrolling */
  width: 100%;
  overflow-x: hidden;
}

.pilihan-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.header-judul-horizontal {
  font-size: 15px;
  font-weight: 700;
  color: white;
}

.header-paket-horizontal {
  font-size: 15px;
  font-weight: 700;
  color: white;
}

.header-soal-horizontal {
  font-size: 15px;
  font-weight: 700;
  color: white;
  background: rgba(255, 255, 255, 0.15);
  padding: 4px 8px;
  border-radius: 8px;
}

.header-separator {
  color: rgba(255, 255, 255, 0.8);
  font-size: 15px;
  font-weight: 700;
}

/* Mobile Header Styles */
.mobile-header-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 64px;
  padding: 16px 12px 8px;
  margin-top: 8px;
}

.mobile-header-top {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 6px;
  text-align: center;
}

.mobile-header-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
}

.mobile-soal-number-main {
  font-size: 14px;
  font-weight: 700;
  color: white;
  text-align: center;
  line-height: 1.3;
  white-space: normal;
  word-wrap: break-word;
  max-width: 100%;
}

.mobile-timer-main {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.15);
  padding: 4px 12px;
  border-radius: 6px;
  justify-content: center;
}

.timer-text-main {
  font-size: 13px;
  font-weight: 600;
  color: white;
}

.mobile-answer-btn-main {
  min-width: 140px !important;
  height: 44px !important;
  padding: 0 20px !important;
  border-radius: 22px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
  touch-action: manipulation !important;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1) !important;
  user-select: none !important;
  transition: all 0.2s ease !important;
}

.mobile-answer-btn-main:active {
  transform: scale(0.95) !important;
  opacity: 0.8 !important;
}

.mobile-answer-btn-main:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
  transform: translateY(-1px) !important;
}

.mobile-btn-text-main {
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 1.2 !important;
}

/* Mobile Landscape Header Styles */
.mobile-landscape-toolbar {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  display: flex !important;
  align-items: center !important;
}

.mobile-landscape-toolbar-content {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 0;
  justify-content: space-between;
}

.mobile-landscape-info {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  color: #fff;
  min-width: 0;
  flex: 0 0 auto;
  overflow: hidden;
  white-space: nowrap;
  padding-left: 8px;
}

.mobile-landscape-spacer {
  flex: 1 1 auto !important;
  min-width: 290px;
}

.mobile-landscape-segment {
  font-size: 14px;
  white-space: nowrap;
  min-width: 0;
  flex: 0 1 auto;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
}

.mobile-landscape-separator {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  font-weight: 700;
}

.mobile-landscape-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  margin-left: auto;
  padding-right: 8px;
}

.mobile-landscape-timer {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.15);
  padding: 4px 12px;
  border-radius: 6px;
  min-width: 95px;
  width: 95px;
}

.mobile-landscape-timer-text {
  font-size: 13px;
  font-weight: 600;
  color: white;
  letter-spacing: 0.5px;
}

.mobile-landscape-answer-btn {
  min-width: 132px !important;
  height: 32px !important;
  padding: 0 18px !important;
  border-radius: 6px !important;
}

.mobile-landscape-btn-text {
  font-size: 12px !important;
  font-weight: 600 !important;
}

@media (max-width: 768px) and (orientation: landscape) {
  .mobile-landscape-toolbar-content {
    gap: 0;
  }

  .mobile-landscape-segment,
  .mobile-landscape-separator {
    font-size: 13px;
  }

  .mobile-landscape-answer-btn {
    min-width: 120px !important;
  }

  .mobile-landscape-actions {
    padding-right: 12px;
  }
}

@media (max-width: 600px) and (orientation: landscape) {
  .mobile-landscape-toolbar-content {
    gap: 0;
  }

  .mobile-landscape-info {
    gap: 6px;
  }

  .mobile-landscape-segment,
  .mobile-landscape-separator {
    font-size: 12px;
  }

  .mobile-landscape-timer-text {
    font-size: 12px;
  }

  .mobile-landscape-btn-text {
    font-size: 11px !important;
  }

  .mobile-landscape-timer {
    padding: 4px 10px;
    min-width: 85px;
    width: 85px;
  }

  .mobile-landscape-actions {
    padding-right: 8px;
  }
}

.mobile-extension-content {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  padding: 0 12px 8px 12px;
  gap: 12px;
}

.mobile-timer {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.15);
  padding: 4px 10px;
  border-radius: 14px;
  min-width: 85px;
  justify-content: center;
}

.timer-text {
  font-size: 13px;
  font-weight: 600;
  color: white;
}

.mobile-answer-btn {
  min-width: 130px !important;
  height: 36px !important;
  padding: 0 16px !important;
  border-radius: 18px !important;
  touch-action: manipulation !important;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1) !important;
  user-select: none !important;
  transition: all 0.2s ease !important;
}

.mobile-answer-btn:active {
  transform: scale(0.95) !important;
  opacity: 0.8 !important;
}

.mobile-answer-btn:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
  transform: translateY(-1px) !important;
}

.mobile-btn-text {
  font-size: 13px !important;
  font-weight: 600 !important;
  line-height: 1.2 !important;
}

.jawaban-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
  padding: 6px;
}

.jawaban-item {
  margin: 0 !important;
  width: 100%;
  min-height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.soal-number-header {
  font-size: 16px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
}

.pilihan-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: transparent;
  border: 2px solid #e0e6ed;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  user-select: none;
  min-height: 70px;
  width: 100%;
  box-sizing: border-box;
}

.pilihan-item>>>p {
  margin: 0 !important;
  padding: 0 !important;
  display: block !important;
  line-height: 1.5 !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  width: 100% !important;
  white-space: normal !important;
  min-height: 40px !important;
}

.pilihan-item:hover {
  border-color: #cde1f3;
  box-shadow: 0 4px 12px rgba(205, 225, 243, 0.15);
  transform: translateY(-2px);
}

/* Desktop specific p tag styling with higher specificity */
.pilihan-item .pilihan-text>>>p,
.pilihan-item>>>.pilihan-text p {
  margin: 0 !important;
  padding: 0 !important;
  display: block !important;
  line-height: 1.5 !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  width: 100% !important;
  white-space: normal !important;
  min-height: 40px !important;
}

/* Pilihan yang sudah dipilih tetap hover */
.pilihan-selected {
  border-color: #cde1f3 !important;
  background-color: #f0fdfc !important;
  box-shadow: 0 4px 12px rgba(205, 225, 243, 0.2) !important;
  transform: translateY(-1px) !important;
}

.pilihan-selected:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 16px rgba(205, 225, 243, 0.3) !important;
}

.pilihan-input {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  flex-shrink: 0;
}

/* Radio Button Styling - Untuk PG Biasa (dengan huruf A,B,C,D) */
.pilihan-label-radio {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: transparent;
  pointer-events: auto;
}

.pilihan-lingkaran-kosong {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 3px solid #cbd5e0;
  border-radius: 50%;
  background: transparent;
  transition: all 0.3s ease;
  font-size: 16px;
  font-weight: bold;
  color: #4a5568;
  pointer-events: auto;
  cursor: pointer;
}

.pilihan-lingkaran-terisi {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 3px solid #4cc5bd;
  border-radius: 50%;
  background: #4cc5bd;
  color: white;
  font-size: 16px;
  font-weight: bold;
  transition: all 0.3s ease;
  pointer-events: auto;
  cursor: pointer;
}

/* Checkbox Styling - Untuk PG Kompleks (tanpa huruf) */
.pilihan-label-checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: transparent;
  pointer-events: auto;
}

.pilihan-kotak-kosong {
  display: inline-block;
  width: 30px;
  height: 30px;
  border: 3px solid #cbd5e0;
  border-radius: 8px;
  background: transparent;
  transition: all 0.3s ease;
  pointer-events: auto;
  cursor: pointer;
}

.pilihan-kotak-terisi {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 3px solid #4cc5bd;
  border-radius: 8px;
  background: #4cc5bd;
  color: white;
  font-size: 16px;
  font-weight: bold;
  transition: all 0.3s ease;
  pointer-events: auto;
  cursor: pointer;
}

.pilihan-text {
  flex: 1;
  color: #2d3748;
  min-height: 40px;
  display: flex;
  align-items: center;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  line-height: 1.5;
  white-space: normal;
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
  padding-right: 8px;
}

/* Styling untuk ordered list dalam pilihan jawaban */
.pilihan-text>>>ol {
  counter-reset: item !important;
  padding-left: 15px !important;
  margin: 0 !important;
  list-style: none !important;
}

.pilihan-text>>>ol>li {
  counter-increment: item !important;
  margin-bottom: 0 !important;
  position: relative !important;
  padding-left: 15px !important;
  line-height: 1.5 !important;
}

.pilihan-text>>>ol>li::before {
  content: counter(item) ". " !important;
  position: absolute !important;
  left: 0 !important;
  top: 0 !important;
  font-weight: bold !important;
  color: #2d3748 !important;
  min-width: 16px !important;
}

/* Styling untuk unordered list dalam pilihan jawaban */
.pilihan-text>>>ul {
  padding-left: 15px !important;
  margin: 0 !important;
  list-style-type: disc !important;
}

.pilihan-text>>>ul>li {
  margin-bottom: 0 !important;
  line-height: 1.5 !important;
  list-style-type: disc !important;
}

/* Text wrapping for pilihan content */
.pilihan-text>>>* {
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  max-width: 100% !important;
  white-space: normal !important;
}

/* Stronger text wrapping rules */
.pilihan-text,
.pilihan-text * {
  word-break: break-word !important;
  overflow-wrap: break-word !important;
  hyphens: auto !important;
  white-space: normal !important;
}

.pilihan-text>>>p {
  margin: 0 !important;
  line-height: 1.5 !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  width: 100% !important;
  display: block !important;
  min-height: 40px !important;
}

/* Fix LaTeX images yang "kepecah" - selector yang lebih spesifik */
.pilihan-text>>>img[src*="latex.codecogs.com"] {
  vertical-align: baseline !important;
  display: inline !important;
  margin: 0 2px !important;
  max-height: 2em !important;
  line-height: 1 !important;
}

/* Hanya untuk LaTeX yang memiliki title dengan backslash atau frac */
.pilihan-text>>>img[title*="\\frac"],
.pilihan-text>>>img[title*="\\"],
.pilihan-text>>>img[title*="frac"] {
  vertical-align: baseline !important;
  display: inline !important;
  margin: 0 2px !important;
  max-height: 2em !important;
  line-height: 1 !important;
}

/* Fix untuk semua mathematical content */
.pilihan-text>>>p {
  margin: 0 !important;
  display: block !important;
  line-height: 1.4 !important;
  min-height: 40px !important;
  width: 100% !important;
}

.pilihan-text>>>sup,
.pilihan-text>>>sub {
  font-size: 0.75em !important;
  line-height: 0 !important;
  position: relative !important;
  vertical-align: baseline !important;
  display: inline !important;
}

.pilihan-text>>>sup {
  top: -0.4em !important;
}

.pilihan-text>>>sub {
  bottom: -0.2em !important;
}

/* Hanya override vertical-align untuk elemen matematika spesifik */
.pilihan-text>>>img[src*="latex.codecogs.com"][style*="vertical-align: middle"],
.pilihan-text>>>img[title*="frac"][style*="vertical-align: middle"] {
  vertical-align: baseline !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .fixed-soal-number {
    top: 80px;
    font-size: 16px;
  }

  .pilihan-container {
    margin-top: 16px;
    padding-top: 20px;
    padding-bottom: 60px;
    /* Reduced padding untuk mobile scroll */
    max-width: 100%;
    overflow: hidden;
  }

  .pilihan-item {
    padding: 12px;
    gap: 12px;
    align-items: center;
    min-height: 50px;
    max-width: 100%;
    overflow: hidden;
  }

  .pilihan-text {
    display: block;
    max-width: 100%;
    overflow: hidden;
    word-wrap: break-word;
  }

  /* Universal mobile button touch enhancements */
  .v-btn {
    touch-action: manipulation !important;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1) !important;
    user-select: none !important;
  }

  /* Ensure minimum touch targets for all answer buttons */
  .mobile-answer-btn,
  .mobile-answer-btn-main,
  .landscape-floating-answer-btn,
  .desktop-answer-btn {
    min-height: 44px !important;
    min-width: 44px !important;
  }

  /* Enhanced visual feedback for mobile interactions */
  .mobile-answer-btn:active,
  .mobile-answer-btn-main:active,
  .landscape-floating-answer-btn:active {
    transform: scale(0.95) !important;
    opacity: 0.85 !important;
  }

  /* Mobile styling untuk HTML content */
  .pilihan-item>>>p {
    margin: 0 !important;
    display: flex !important;
    align-items: center !important;
    line-height: 1.5 !important;
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    white-space: normal !important;
    min-height: 40px !important;
    max-width: 100% !important;
    overflow: hidden !important;
  }

  /* Mobile Header Responsive */
  .mobile-header-text {
    font-size: 12px;
    max-width: 120px;
  }

  .mobile-soal-number {
    font-size: 11px;
    padding: 2px 8px;
  }

  .timer-text {
    font-size: 12px;
  }

  .mobile-btn-text {
    font-size: 11px !important;
  }

  .pilihan-input {
    min-width: 36px;
    height: 36px;
  }

  .pilihan-label-radio,
  .pilihan-label-checkbox {
    width: 36px;
    height: 36px;
  }

  .pilihan-lingkaran-kosong,
  .pilihan-lingkaran-terisi,
  .pilihan-kotak-kosong,
  .pilihan-kotak-terisi {
    width: 26px;
    height: 26px;
    font-size: 14px;
  }

  /* Fix untuk konten soal di mobile - lebih stabil */
  .soal-content {
    padding: 16px 0 20px 0 !important;
    font-size: 16px !important;
    line-height: 1.7 !important;
    max-width: 100% !important;
    overflow-x: hidden !important;
    overflow-y: visible !important;
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    white-space: normal !important;
  }

  .soal-content>>>p {
    margin-bottom: 16px !important;
    line-height: 1.7 !important;
    max-width: 100% !important;
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    white-space: normal !important;
    overflow: visible !important;
  }

  .soal-content>>>img:not([src*="latex.codecogs.com"]) {
    max-width: 100% !important;
    height: auto !important;
    margin: 12px auto !important;
    display: block !important;
  }

  /* Global overflow control untuk mobile */
  .v-carousel {
    overflow: hidden !important;
  }

  .v-carousel__item {
    overflow: hidden !important;
  }

  .v-container {
    position: relative !important;
    overflow-x: hidden !important;
    max-width: 100% !important;
  }

  /* Pastikan semua konten tidak keluar dari container */
  .default-font {
    max-width: 100% !important;
    overflow: hidden !important;
  }

  .default-font>>>* {
    max-width: 100% !important;
    overflow: hidden !important;
  }
}

@media (max-width: 480px) {
  .pilihan-item {
    flex-direction: row;
    align-items: center;
    text-align: left;
    gap: 12px;
    padding: 12px 8px;
    min-height: 48px;
  }

  .pilihan-text {
    flex: 1;
    min-height: 48px;
    display: block;
  }

  /* Small mobile styling untuk HTML content */
  .pilihan-item>>>p {
    margin: 0 !important;
    display: flex !important;
    align-items: center !important;
    line-height: 1.5 !important;
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    white-space: normal !important;
    min-height: 40px !important;
  }

  /* Extra small mobile adjustments */
  .mobile-header-content {
    padding: 12px 4px 6px;
    min-height: 60px;
  }

  .mobile-header-text {
    font-size: 11px;
    max-width: 100px;
  }

  .mobile-separator {
    font-size: 11px;
    margin: 0 2px;
  }

  .mobile-soal-number {
    font-size: 10px;
    padding: 2px 6px;
  }

  .mobile-extension-content {
    padding: 0 6px 6px 6px;
    gap: 8px;
  }

  .mobile-timer {
    min-width: 75px;
    padding: 3px 8px;
  }

  .timer-text {
    font-size: 11px;
  }

  .mobile-answer-btn {
    min-width: 120px !important;
    height: 40px !important;
  }

  .mobile-btn-text {
    font-size: 12px !important;
  }

  /* Ensure portrait mobile button maintains good touch target */
  .mobile-answer-btn-main {
    min-width: 130px !important;
    height: 42px !important;
    font-size: 13px !important;
  }
}

/* .default-font{
          font-family: 'Times New Roman', Times, serif;
      } */

/* Simple mobile layout */
@media (max-width: 768px) {
  .device-height-50 {
    height: 50vh !important;
    /* Dikurangi karena toolbar sticky */
  }

  .device-height-60 {
    height: calc(70vh - 120px) !important;
    /* Dikurangi height toolbar */
  }

  /* Toolbar sticky settings */
  .toolbar-sticky {
    position: sticky !important;
    top: 0 !important;
    z-index: 100 !important;
  }

  /* Container scroll area yang lebih kecil */
  .v-container[style*="overflow-y:scroll"] {
    height: calc(60vh - 80px) !important;
    max-height: calc(60vh - 80px) !important;
  }

  /* Scroll container khusus mobile dengan sticky toolbar */
  .scroll-container-mobile {
    height: calc(60vh - 60px) !important;
    max-height: calc(60vh - 60px) !important;
    position: relative !important;
  }
}

/* Additional optimization for very small mobile devices */
@media (max-width: 360px) {
  .mobile-answer-btn-main {
    min-width: 120px !important;
    height: 44px !important;
    font-size: 12px !important;
    padding: 0 16px !important;
  }

  .mobile-btn-text-main {
    font-size: 12px !important;
  }
}

/* Portrait orientation specific optimizations */
@media (max-width: 768px) and (orientation: portrait) {
  .mobile-answer-btn-main {
    margin-left: 8px !important;
    margin-top: 4px !important;
  }

  .scroll-container-mobile {
    top: 0 !important;
    overflow-x: auto !important;
    /* Allow horizontal scroll untuk mobile */
    overflow-y: auto !important;
  }

  /* Untuk konten yang butuh scroll horizontal, override container */
  .scroll-container-mobile:has(.horizontal-scrollable-content) {
    overflow-x: auto !important;
  }

  /* Pastikan carousel item tidak overflow */
  .v-carousel__item {
    overflow: hidden !important;
    max-height: 75vh !important;
  }
}

@media (max-width: 768px) {

  /* Padding top untuk konten di bawah sticky toolbar */
  .carousel-with-sticky-header .v-carousel__item {
    padding-top: 0 !important;
  }

  .v-card__text {
    padding-bottom: 100px !important;
  }

  /* V-card-text khusus untuk konten horizontal scrollable */
  .v-card__text:has(.horizontal-scrollable-content) {
    overflow-x: auto !important;
    min-width: 100% !important;
  }

  .v-toolbar.v-toolbar--bottom {
    height: 70px !important;
  }
}

@media (max-width: 768px) and (orientation: portrait) {

  /* Portrait mobile - tinggi yang disesuaikan */
  .device-height-50 {
    height: 78vh !important;
  }

  .device-height-60 {
    height: 83vh !important;
  }

  /* Scroll area untuk portrait */
  .v-container[style*="overflow-y:scroll"] {
    max-height: 71vh !important;
  }

  .v-carousel__item {
    max-height: 71vh !important;
  }

  .v-card__text {
    padding-bottom: 80px !important;
  }
}

@media (max-width: 480px) {

  /* Small mobile devices - tinggi maksimal tapi terkontrol */
  .device-height-50 {
    height: 85vh !important;
  }

  .device-height-60 {
    height: 90vh !important;
  }

  .v-container[style*="overflow-y:scroll"] {
    max-height: 82vh !important;
  }

  .v-carousel__item {
    max-height: 82vh !important;
  }
}

/* iPhone SE dan device dengan tinggi layar kecil (≤667px) */
@media (max-width: 480px) and (max-height: 667px) {
  .device-height-50 {
    height: 82vh !important;
  }

  .device-height-60 {
    height: 87vh !important;
  }

  .v-container[style*="overflow-y:scroll"] {
    max-height: 75vh !important;
  }

  .v-carousel__item {
    max-height: 75vh !important;
  }

  .v-card__text {
    padding-bottom: 60px !important;
  }
}

/* iPhone 14 Pro Max dan device dengan tinggi layar besar (≥844px) */
@media (max-width: 480px) and (min-height: 844px) {
  .device-height-50 {
    height: 75vh !important;
  }

  .device-height-60 {
    height: 80vh !important;
  }

  .v-container[style*="overflow-y:scroll"] {
    max-height: 72vh !important;
  }

  .v-carousel__item {
    max-height: 72vh !important;
  }

  .v-card__text {
    padding-bottom: 80px !important;
  }
}

/* Ultra small devices seperti iPhone SE dalam landscape */
@media (max-width: 667px) and (max-height: 375px) and (orientation: landscape) {
  .device-height-50 {
    height: 85vh !important;
  }

  .device-height-60 {
    height: 90vh !important;
  }

  .v-container[style*="overflow-y:scroll"] {
    max-height: 82vh !important;
  }

  .v-carousel__item {
    max-height: 82vh !important;
  }

  .v-card__text {
    padding-bottom: 50px !important;
  }
}

/* Landscape mobile - tinggi lebih kecil karena layar pendek */
@media (max-width: 768px) and (orientation: landscape) {
  .device-height-50 {
    height: 75vh !important;
  }

  .device-height-60 {
    height: 80vh !important;
  }

  .v-container[style*="overflow-y:scroll"] {
    max-height: 72vh !important;
  }

  .v-carousel__item {
    max-height: 72vh !important;
  }
}

@media (max-width: 480px) and (orientation: portrait) {
  .pilihan-container {
    margin-top: 16px !important;
    padding-bottom: 16px !important;
  }

  .pilihan-list {
    gap: 12px !important;
  }
}

/* Fix LaTeX images di konten soal - selector yang lebih spesifik */
.default-font>>>img[src*="latex.codecogs.com"] {
  vertical-align: baseline !important;
  display: inline !important;
  margin: 0 2px !important;
  max-height: 2em !important;
  line-height: 1 !important;
}

/* Hanya untuk LaTeX yang memiliki title dengan backslash atau frac */
.default-font>>>img[title*="\\frac"],
.default-font>>>img[title*="\\"],
.default-font>>>img[title*="frac"] {
  vertical-align: baseline !important;
  display: inline !important;
  margin: 0 2px !important;
  max-height: 2em !important;
  line-height: 1 !important;
}

.default-font>>>p {
  line-height: 1.6 !important;
  margin-bottom: 12px !important;
}

/* Styling untuk ordered dan unordered list dalam default-font */
.default-font>>>ol {
  counter-reset: item !important;
  padding-left: 15px !important;
  margin: 0 !important;
  list-style: none !important;
}

.default-font>>>ol>li {
  counter-increment: item !important;
  margin-bottom: 0 !important;
  position: relative !important;
  padding-left: 15px !important;
  line-height: 1.6 !important;
}

.default-font>>>ol>li::before {
  content: counter(item) ". " !important;
  position: absolute !important;
  left: 0 !important;
  top: 0 !important;
  font-weight: bold !important;
  color: #000000 !important;
  min-width: 18px !important;
}

.default-font>>>ul {
  padding-left: 15px !important;
  margin: 0 !important;
  list-style-type: disc !important;
}

.default-font>>>ul>li {
  margin-bottom: 0 !important;
  line-height: 1.6 !important;
  list-style-type: disc !important;
}

.default-font>>>sup,
.default-font>>>sub {
  font-size: 0.75em !important;
  line-height: 0 !important;
  position: relative !important;
  vertical-align: baseline !important;
}

.default-font>>>sup {
  top: -0.4em !important;
}

.default-font>>>sub {
  bottom: -0.2em !important;
}

/* Hanya override vertical-align untuk LaTeX matematika spesifik */
.default-font>>>img[src*="latex.codecogs.com"][style*="vertical-align: middle"],
.default-font>>>img[title*="frac"][style*="vertical-align: middle"] {
  vertical-align: baseline !important;
}

/* Styling untuk konten soal agar tidak terpotong dan tidak overflow */
.soal-content {
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  hyphens: auto !important;
  white-space: normal !important;
  margin-bottom: 16px !important;
  max-width: 100% !important;
  overflow-x: hidden !important;
  overflow-y: visible !important;
}

.soal-content>>>* {
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  max-width: 100% !important;
  white-space: normal !important;
}

/* Styling khusus untuk ordered list (numbering) dalam konten soal - FIXED LAYOUT */
.soal-content>>>ol {
  counter-reset: item !important;
  margin: 8px 0 !important;
  padding-left: 0 !important;
  list-style: none !important;
}

.soal-content>>>ol>li {
  counter-increment: item !important;
  margin-bottom: 4px !important;
  line-height: 1.6 !important;
  display: block !important;
  position: relative !important;
  padding-left: 24px !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
}

.soal-content>>>ol>li::before {
  content: counter(item) ". " !important;
  font-weight: bold !important;
  color: #333 !important;
  position: absolute !important;
  left: 0 !important;
  top: 0 !important;
  width: 20px !important;
  text-align: left !important;
}

/* Styling untuk unordered list - FIXED LAYOUT */
.soal-content>>>ul {
  margin: 8px 0 !important;
  padding-left: 0 !important;
  list-style: none !important;
}

.soal-content>>>ul>li {
  margin-bottom: 4px !important;
  line-height: 1.6 !important;
  display: block !important;
  position: relative !important;
  padding-left: 16px !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
}

.soal-content>>>ul>li::before {
  content: "• " !important;
  font-weight: bold !important;
  color: #666 !important;
  position: absolute !important;
  left: 0 !important;
  top: 0 !important;
  width: 12px !important;
  text-align: left !important;
}

/* Styling untuk nested lists - FIXED LAYOUT dengan proper indentasi */
.soal-content>>>ol ol,
.soal-content>>>ul ul,
.soal-content>>>ol ul,
.soal-content>>>ul ol {
  margin: 4px 0 !important;
  padding-left: 20px !important;
}

.soal-content>>>ol ol>li {
  counter-increment: subitem !important;
  padding-left: 28px !important;
}

.soal-content>>>ol ol>li::before {
  content: counter(item) "." counter(subitem) " " !important;
  color: #666 !important;
  width: 24px !important;
}

.soal-content>>>ul ul>li {
  padding-left: 20px !important;
}

.soal-content>>>ul ul>li::before {
  content: "◦ " !important;
  color: #888 !important;
  width: 16px !important;
}

/* 
  ALTERNATIF STYLING JIKA INGIN LIST DENGAN BROWSER DEFAULT STYLE:
  
  Ganti CSS di atas dengan kode ini untuk list style browser default:
  
  .soal-content>>>ol {
    margin: 8px 0 !important;
    padding-left: 30px !important;
    list-style: decimal !important;
  }

  .soal-content>>>ol>li {
    margin-bottom: 4px !important;
    line-height: 1.6 !important;
    list-style: decimal !important;
    padding-left: 0 !important;
  }

  .soal-content>>>ol>li::before {
    display: none !important;
  }

  .soal-content>>>ul {
    margin: 8px 0 !important;
    padding-left: 30px !important;
    list-style: disc !important;
  }

  .soal-content>>>ul>li {
    margin-bottom: 4px !important;
    line-height: 1.6 !important;
    list-style: disc !important;
    padding-left: 0 !important;
  }

  .soal-content>>>ul>li::before {
    display: none !important;
  }
*/

.soal-content>>>p {
  margin-bottom: 12px !important;
  line-height: 1.6 !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  white-space: normal !important;
  max-width: 100% !important;
}

.soal-content>>>img {
  max-width: 100% !important;
  height: auto !important;
  display: block !important;
  margin: 8px auto !important;
}

/* Fix untuk LaTeX di konten soal */
.soal-content>>>img[src*="latex.codecogs.com"] {
  display: inline !important;
  vertical-align: baseline !important;
  margin: 0 2px !important;
  max-height: 2em !important;
}

/* Global container overflow control */
@media (max-width: 768px) {

  /* Pastikan semua container tidak overflow, kecuali yang butuh scroll horizontal */
  .v-card,
  .v-card__text,
  .v-container,
  .v-carousel,
  .v-carousel__item {
    max-width: 100% !important;
    overflow-x: hidden !important;
  }

  /* Exception untuk konten yang butuh scroll horizontal */
  .horizontal-scrollable-content {
    overflow-x: auto !important;
    max-width: none !important;
  }

  /* Kontrol konten dalam pilihan jawaban biasa (bukan matching/pg_kategori) */
  .pilihan-item,
  .pilihan-text {
    max-width: 100% !important;
    overflow: hidden !important;
    word-wrap: break-word !important;
  }

  /* Kontrol default font container, kecuali yang horizontal scrollable */
  .default-font:not(.horizontal-scrollable-content) {
    max-width: 100% !important;
    overflow-x: hidden !important;
  }

  /* Kontrol untuk semua text content biasa - lebih lenient */
  .default-font:not(.horizontal-scrollable-content)>>>p,
  .default-font:not(.horizontal-scrollable-content)>>>div,
  .default-font:not(.horizontal-scrollable-content)>>>span {
    max-width: 100% !important;
    overflow-wrap: break-word !important;
    word-wrap: break-word !important;
    white-space: normal !important;
  }

  /* Preserve list styling di mobile */
  .default-font:not(.horizontal-scrollable-content)>>>ol,
  .default-font:not(.horizontal-scrollable-content)>>>ul,
  .soal-content>>>ol,
  .soal-content>>>ul,
  .pilihan-text>>>ol,
  .pilihan-text>>>ul {
    display: block !important;
    list-style: initial !important;
  }

  .default-font:not(.horizontal-scrollable-content)>>>ol,
  .soal-content>>>ol,
  .pilihan-text>>>ol {
    list-style: none !important;
  }

  .default-font:not(.horizontal-scrollable-content)>>>ul,
  .soal-content>>>ul,
  .pilihan-text>>>ul {
    list-style-type: disc !important;
  }

  /* Pastikan carousel tidak terlalu besar atau kecil */
  .v-carousel__item {
    max-height: 72vh !important;
  }

  /* Additional mobile responsive fixes for pilihan-container */
  .pilihan-container {
    padding: 8px !important;
    margin: 8px 0 !important;
  }

  .pilihan-item {
    padding: 12px !important;
    gap: 12px !important;
    min-height: 60px !important;
    margin-bottom: 8px !important;
  }

  .pilihan-text {
    font-size: 14px !important;
    line-height: 1.4 !important;
    padding-right: 4px !important;
  }

  .pilihan-input {
    min-width: 36px !important;
  }

  .pilihan-lingkaran-kosong,
  .pilihan-lingkaran-terisi,
  .pilihan-kotak-kosong,
  .pilihan-kotak-terisi {
    width: 36px !important;
    height: 36px !important;
    font-size: 14px !important;
  }

  /* Pastikan text dalam pilihan tidak overflow */
  .pilihan-text>>>p,
  .pilihan-text>>>div,
  .pilihan-text>>>span,
  .pilihan-text>>>* {
    max-width: 100% !important;
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    white-space: normal !important;
    hyphens: auto !important;
    line-height: 1.4 !important;
  }
}

/* Extra small mobile devices */
@media (max-width: 400px) {
  .pilihan-container {
    padding: 6px !important;
    margin: 6px 0 !important;
  }

  .pilihan-item {
    padding: 10px !important;
    gap: 10px !important;
    min-height: 55px !important;
    flex-direction: row !important;
    align-items: center !important;
  }

  .pilihan-text {
    font-size: 13px !important;
    line-height: 1.3 !important;
    padding-right: 2px !important;
  }

  .pilihan-input {
    min-width: 32px !important;
    flex-shrink: 0 !important;
  }

  .pilihan-lingkaran-kosong,
  .pilihan-lingkaran-terisi,
  .pilihan-kotak-kosong,
  .pilihan-kotak-terisi {
    width: 32px !important;
    height: 32px !important;
    font-size: 13px !important;
  }

  /* Ensure text content fits in small screens */
  .pilihan-text>>>p,
  .pilihan-text>>>div,
  .pilihan-text>>>span {
    font-size: 13px !important;
    line-height: 1.3 !important;
    margin: 5px 0 !important;
    padding: 0 !important;
  }
}

/* Fix untuk tag em, i, strong, b agar tetap inline di pilihan jawaban */
.pilihan-text>>>em,
.pilihan-text>>>i,
.pilihan-text>>>strong,
.pilihan-text>>>b {
  display: inline !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  white-space: normal !important;
  max-width: none !important;
  font-style: italic !important;
  /* Pastikan em dan i tetap italic */
  font-weight: inherit !important;
}

/* Override untuk konten dalam pilihan text agar tetap inline flow normal */
.pilihan-text>>>em,
.pilihan-text>>>i,
.pilihan-text>>>strong,
.pilihan-text>>>b,
.pilihan-text>>>span,
.pilihan-text>>>a,
.pilihan-text>>>code {
  display: inline !important;
  vertical-align: baseline !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  white-space: normal !important;
}

/* Pastikan paragraph tetap block untuk flow text yang normal */
.pilihan-text>>>p {
  display: block !important;
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1.5 !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  white-space: normal !important;
}

/* Pastikan div juga block jika digunakan */
.pilihan-text>>>div {
  display: block !important;
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1.5 !important;
}

/* Exception untuk images */
.pilihan-text>>>img {
  display: inline !important;
  max-width: 100% !important;
  height: auto !important;
  vertical-align: middle !important;
}

/* Styling untuk tombol tutup lembar jawaban */
.v-navigation-drawer .v-btn--icon {
  background-color: rgba(255, 255, 255, 0.1) !important;
  border-radius: 50% !important;
  transition: all 0.3s ease !important;
}

.v-navigation-drawer .v-btn--icon:hover {
  background-color: rgba(255, 255, 255, 0.2) !important;
  transform: scale(1.1) !important;
}

.v-navigation-drawer .v-btn--icon .v-icon {
  color: #666 !important;
}

.v-navigation-drawer .v-btn--icon:hover .v-icon {
  color: #333 !important;
}

/* Responsive styling untuk tombol tutup */
@media (min-width: 960px) {
  .v-navigation-drawer .v-btn--icon {
    background-color: rgba(0, 0, 0, 0.05) !important;
  }

  .v-navigation-drawer .v-btn--icon:hover {
    background-color: rgba(0, 0, 0, 0.1) !important;
  }
}

/* Perbaikan khusus untuk mobile - text content soal yang stabil */
@media (max-width: 768px) {

  /* List styling konsisten dengan desktop - FIXED LAYOUT */
  .soal-content>>>ol,
  .soal-content>>>ul {
    margin: 8px 0 !important;
    padding-left: 0 !important;
  }

  .soal-content>>>ol>li {
    margin-bottom: 4px !important;
    line-height: 1.6 !important;
    padding-left: 24px !important;
  }

  .soal-content>>>ul>li {
    margin-bottom: 4px !important;
    line-height: 1.6 !important;
    padding-left: 16px !important;
  }

  /* Nested list dengan proper spacing */
  .soal-content>>>ol ol,
  .soal-content>>>ul ul,
  .soal-content>>>ol ul,
  .soal-content>>>ul ol {
    padding-left: 16px !important;
  }

  .soal-content>>>ol ol>li {
    padding-left: 28px !important;
  }

  .soal-content>>>ul ul>li {
    padding-left: 20px !important;
  }

  /* Perbaikan untuk elemen inline dalam soal */
  .soal-content>>>em,
  .soal-content>>>i,
  .soal-content>>>strong,
  .soal-content>>>b,
  .soal-content>>>span {
    display: inline !important;
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
  }

  /* Pastikan table responsive jika ada */
  .soal-content>>>table {
    max-width: 100% !important;
    overflow-x: auto !important;
    display: block !important;
    white-space: nowrap !important;
  }

  /* Fix untuk div dalam soal content */
  .soal-content>>>div {
    max-width: 100% !important;
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    white-space: normal !important;
  }

  /* Pastikan konten tidak terpotong di mobile */
  .default-font {
    overflow-x: hidden !important;
    overflow-y: visible !important;
  }
}

/* Desktop font size untuk pilihan jawaban - lebih besar untuk readability */
@media (min-width: 960px) {

  /* Pilihan jawaban dengan selector yang lebih spesifik */
  .pilihan-item .pilihan-text,
  .pilihan-item .pilihan-text *,
  .pilihan-text,
  .pilihan-text * {
    font-size: 16px !important;
    line-height: 1.6 !important;
  }

  .pilihan-item .pilihan-text>>>p,
  .pilihan-text>>>p {
    font-size: 16px !important;
    line-height: 1.6 !important;
  }

  .pilihan-item .pilihan-text>>>div,
  .pilihan-text>>>div {
    font-size: 16px !important;
    line-height: 1.6 !important;
  }

  .pilihan-item .pilihan-text>>>span,
  .pilihan-text>>>span {
    font-size: 16px !important;
    line-height: 1.6 !important;
  }

  .pilihan-item .pilihan-text>>>li,
  .pilihan-text>>>li {
    font-size: 16px !important;
    line-height: 1.6 !important;
  }

  .pilihan-item .pilihan-text>>>strong,
  .pilihan-item .pilihan-text>>>b,
  .pilihan-item .pilihan-text>>>em,
  .pilihan-item .pilihan-text>>>i,
  .pilihan-text>>>strong,
  .pilihan-text>>>b,
  .pilihan-text>>>em,
  .pilihan-text>>>i {
    font-size: 16px !important;
    line-height: 1.6 !important;
  }

  /* Ensure ordered list numbers also use larger font */
  .pilihan-item .pilihan-text>>>ol>li::before,
  .pilihan-text>>>ol>li::before {
    font-size: 16px !important;
  }

  /* Larger padding for better desktop spacing */
  .pilihan-item .pilihan-text,
  .pilihan-text {
    padding-right: 12px !important;
    min-height: 48px !important;
  }

  /* Font size untuk item-pernyataan di desktop dengan selector lebih spesifik */
  .item-pernyataan,
  .item-pernyataan *,
  .matching-item .item-pernyataan,
  .matching-item .item-pernyataan * {
    font-size: 16px !important;
    line-height: 1.6 !important;
  }

  .item-pernyataan>>>p,
  .matching-item .item-pernyataan>>>p {
    font-size: 16px !important;
    line-height: 1.6 !important;
  }

  .item-pernyataan>>>div,
  .matching-item .item-pernyataan>>>div {
    font-size: 16px !important;
    line-height: 1.6 !important;
  }

  .item-pernyataan>>>span,
  .matching-item .item-pernyataan>>>span {
    font-size: 16px !important;
    line-height: 1.6 !important;
  }

  .item-pernyataan>>>li,
  .matching-item .item-pernyataan>>>li {
    font-size: 16px !important;
    line-height: 1.6 !important;
  }

  .item-pernyataan>>>strong,
  .item-pernyataan>>>b,
  .item-pernyataan>>>em,
  .item-pernyataan>>>i,
  .matching-item .item-pernyataan>>>strong,
  .matching-item .item-pernyataan>>>b,
  .matching-item .item-pernyataan>>>em,
  .matching-item .item-pernyataan>>>i {
    font-size: 16px !important;
    line-height: 1.6 !important;
  }

  /* Larger padding for item-pernyataan */
  .item-pernyataan,
  .matching-item .item-pernyataan {
    padding-right: 12px !important;
    min-height: 48px !important;
  }

  /* Override any default-font atau class lain yang mungkin mengatur font size */
  .default-font .pilihan-text,
  .default-font .pilihan-text *,
  .default-font .item-pernyataan,
  .default-font .item-pernyataan * {
    font-size: 16px !important;
    line-height: 1.6 !important;
  }
}

/* Audio Element Styling - CRITICAL FIX untuk mobile */
.soal-audio {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  margin: 16px 0 !important;
  display: block !important;
  position: relative !important;
  z-index: 1 !important;
  background-color: #f5f5f5 !important;
  border-radius: 8px !important;
  border: 1px solid #e0e0e0 !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  outline: none !important;
}

.soal-audio:focus {
  outline: 2px solid #1976d2 !important;
  outline-offset: 2px !important;
}

/* Desktop Audio Styling */
@media (min-width: 960px) {
  .soal-audio {
    width: 100% !important;
    max-width: 500px !important;
    margin: 20px 0 !important;
    height: 54px !important;
    background-color: #ffffff !important;
    border: 2px solid #e0e0e0 !important;
    border-radius: 12px !important;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
  }

  .soal-audio:hover {
    border-color: #1976d2 !important;
    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.2) !important;
  }
}

/* Mobile Audio Styling - VERY IMPORTANT */
@media (max-width: 768px) {
  .soal-audio {
    width: 100% !important;
    max-width: 100% !important;
    min-height: 48px !important;
    height: auto !important;
    margin: 16px 0 !important;
    display: block !important;
    position: relative !important;
    z-index: 10 !important;
    background-color: #ffffff !important;
    border: 2px solid #1976d2 !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
    visibility: visible !important;
    opacity: 1 !important;
    overflow: visible !important;
    -webkit-appearance: none !important;
    appearance: none !important;
  }

  .soal-audio::-webkit-media-controls-panel {
    background-color: #ffffff !important;
    border-radius: 6px !important;
  }

  .soal-audio::-webkit-media-controls-play-button,
  .soal-audio::-webkit-media-controls-timeline,
  .soal-audio::-webkit-media-controls-time-remaining-display,
  .soal-audio::-webkit-media-controls-current-time-display,
  .soal-audio::-webkit-media-controls-mute-button,
  .soal-audio::-webkit-media-controls-volume-slider {
    color: #1976d2 !important;
    filter: none !important;
  }

  /* Ensure audio is not hidden by container overflow */
  .soal-audio::-webkit-media-controls {
    overflow: visible !important;
  }
}

/* Landscape Mobile Audio Styling */
@media (max-width: 768px) and (orientation: landscape) {
  .soal-audio {
    margin: 12px 0 !important;
    min-height: 44px !important;
    max-width: 100% !important;
  }
}

/* Extra Small Mobile Audio Styling */
@media (max-width: 480px) {
  .soal-audio {
    margin: 12px 0 !important;
    min-height: 42px !important;
    border-width: 2px !important;
    font-size: 14px !important;
  }
}

/* Very Small Mobile Audio Styling */
@media (max-width: 360px) {
  .soal-audio {
    margin: 8px 0 !important;
    min-height: 40px !important;
    border-width: 1px !important;
  }
}

/* Audio Container Fix */
.soal-content .soal-audio {
  overflow: visible !important;
  max-width: 100% !important;
  width: 100% !important;
  box-sizing: border-box !important;
}

/* Ensure audio is not affected by text styling */
.default-font .soal-audio,
.black--text .soal-audio {
  color: initial !important;
  font-family: initial !important;
  font-size: initial !important;
}

/* Force audio visibility on all mobile browsers */
@media (max-width: 768px) {

  .v-card__text .soal-audio,
  .v-container .soal-audio,
  .v-carousel__item .soal-audio {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    position: relative !important;
    z-index: 10 !important;
  }

  /* Ensure parent containers don't hide audio */
  .v-card__text:has(.soal-audio),
  .soal-content:has(.soal-audio),
  .v-container:has(.soal-audio) {
    overflow: visible !important;
  }

  /* Alternative for browsers that don't support :has() */
  .v-card__text .soal-audio,
  .soal-content .soal-audio {
    margin: 16px 0 !important;
    clear: both !important;
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    position: relative !important;
    z-index: 15 !important;
  }
}

/* Additional mobile fixes for audio positioning */
@media (max-width: 768px) {

  /* Ensure audio doesn't get clipped by container boundaries */
  .default-font .soal-audio,
  .black--text .soal-audio {
    position: relative !important;
    z-index: 20 !important;
    margin: 20px 0 !important;
    padding: 4px !important;
    background: white !important;
    border-radius: 8px !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  }

  /* Make sure carousel doesn't clip audio */
  .v-carousel,
  .v-carousel__item {
    overflow: visible !important;
  }

  /* Specific fix for Vue transitions not hiding audio */
  .v-carousel__item.v-carousel__item--active .soal-audio {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
}

/* CRITICAL: Ensure buttons are always visible - fallback rules */
.v-card-actions {
  display: flex !important;
  visibility: visible !important;
  opacity: 1 !important;
  position: relative !important;
  z-index: 100 !important;
  background: white !important;
  min-height: 80px !important;
}

.v-card-actions .v-btn {
  display: inline-flex !important;
  visibility: visible !important;
  opacity: 1 !important;
  position: relative !important;
  z-index: 1 !important;
  min-height: 40px !important;
  min-width: 64px !important;
}

.v-card-actions .v-layout {
  display: flex !important;
  width: 100% !important;
  justify-content: space-between !important;
  align-items: center !important;
}

.v-card-actions .d-flex {
  display: flex !important;
  align-items: center !important;
}

/* Specific fixes for desktop breakpoints */
@media (min-width: 960px) {
  .v-card-actions[class*="pa-5"] {
    padding: 16px 20px !important;
    display: flex !important;
    visibility: visible !important;
    opacity: 1 !important;
    position: relative !important;
    z-index: 100 !important;
  }
}

/* Progress Bar Ujian */
.progress-ujian-wrapper {
  padding: 0 4px;
  margin-bottom: 4px;
}

.progress-ujian-landscape {
  padding: 0 8px;
  margin-bottom: 2px;
}

/* Auto-save indicator */
.auto-save-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  margin: 4px auto;
  background-color: rgba(76, 175, 80, 0.08);
  border-radius: 16px;
  width: fit-content;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* Fix 23: Orientation detection CSS media queries */
@media screen and (orientation: landscape) and (max-height: 500px) {
  .progress-ujian-wrapper {
    margin-bottom: 0;
  }

  .progress-ujian-wrapper .v-progress-linear {
    height: 18px !important;
  }

  .btn-kembali {
    margin-bottom: 8px !important;
    margin-top: 8px !important;
  }
}

@media screen and (orientation: portrait) and (max-width: 600px) {
  .progress-ujian-wrapper {
    padding: 0 8px;
    margin-bottom: 8px;
  }
}
</style>
